import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import Select from 'react-select';
import { redirect, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RetrieveSelectedFlight, GetFrequentFlyersNoByAirline } from "../../Services/API";
//import { RetrieveAgentDetails } from "../../Services/API";
import { RetrieveCorporateDetails } from "../../Services/API";
import { AddPassengerDetails } from "../../Services/API";
import { CollectPayment } from "../../Services/API";
import { FlightBooking } from "../../Services/API";
import { SpecialService } from '../../Services/API';
import SeatAvailability from "../../Products/Flight/SeatAvailability";
import { AuthContext } from "../../Routes/AuthProvider"
import { GetSeatAvailability } from "../../Services/API";
import { ApprovalRequest } from "../../Services/ApprovalAPI";
import { GetOrganizationsType } from "../../Services/API";
import { GetCountriesList } from "../../Services/API";
import { getAutoAirlines } from "../../Services/API";
import { CreateCorporateTravellerProfile } from "../../Services/API";
import { SendPaymentLinkMail } from "../../Services/PaymentLink";
import FlightSeatSelection from "../../Products/Flight/FlightSeatSelection";
import { GetCorporateDetailsForBilling } from "../../Services/API";
import { TravelPolicies } from "../../Services/API";
import { ApprovalPolicy } from "../../Services/ApprovalAPI";
import { CheckDuplicateBooking } from "../../Services/DuplicateBookingCheckAPI";

const Booking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [flightAvailibilies, setFlightAvailibilies] = useState(null);
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  const queryParams = new URLSearchParams(location.search);
  const [show, setShow] = useState(false);
  const [departureCity, setDepartureCity] = useState(null);
  const [arrivalCity, setArrivalCity] = useState(null);
  const [travelType, setTravelType] = useState("Domestic");
  const [policies, setPolicies] = useState([]);
  const [approvalPolicies, setApprovalPolicies] = useState([]);
  const [policyData, setPolicyData] = useState(null);
  const [companyMarkup, setCompanyMarkup] = useState("");

  const [isSeatRequired, setIsSeatRequired] = useState(false);
  const [isBaggageRequired, setIsBaggageRequired] = useState(false);
  const [isMealRequired, setIsMealRequired] = useState(false);

  const [duplicateMessage, setDuplicateMessage] = useState("");
  const [duplicateReferenceNo, setDuplicateReferenceNo] = useState("");
  const [duplicateTrackId, setDuplicateTrackId] = useState("");

  useEffect(() => {
    if (!flightAvailibilies?.length) return;

    const total = flightAvailibilies.reduce(
      (sum, x) =>
        sum + parseFloat(x?.fareDetails?.companyMarkUp || 0),
      0
    );

    setCompanyMarkup(total === 0 ? "" : total.toFixed(2));

  }, [flightAvailibilies]);

  const showHide = () => {
    setShow(!show);
  };

  const [seatAvailability, setSeatAvailability] = useState([]);

  const userRole = roles?.[0];

  const isTmcAdmin = roles?.includes("TMC Operations");

  // countries list start

  const [countries, setCountries] = useState([]);
  const [airlines, setAirlines] = useState([]);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await GetCountriesList();
        setCountries(data || []);
      } catch (error) {
        console.error("Failed to load countries", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchAirlines = async () => {
      try {
        const data = await getAutoAirlines("");
        setAirlines(data || []);
      } catch (error) {
        console.error("Failed to load Airlines", error);
      }
    };

    fetchAirlines();
  }, []);
  const today = new Date();

  const getDateYearsAgo = (years) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - years);
    return date;
  };
  // countries list End

  const [selectedFlight, setSelectedFlight] = useState(null);

  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }

  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const clientCode = getParamIgnoreCase("ClientCode");
  const key = getParamIgnoreCase("Key");

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    confirmName: "",
    payment: "",
  });

  const [selectedFlightData, setSelectedFlightData] = useState(null); // Store API response here
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [totalBFare, setTotalBFare] = useState(0);
  const [totalFare, setTotalFare] = useState(0);
  const [adultTotalBaseFare, setAdultTotalBaseFare] = useState(0);
  const [childTotalBaseFare, setChildTotalBaseFare] = useState(0);
  const [infantTotalBaseFare, setInfantTotalBaseFare] = useState(0);

  const [agencyDetails, setAgencyDetails] = useState(null);
  const [paxCount, setPaxCount] = useState(null);
  const [oF, setOF] = useState(null);
  const [rF, setRF] = useState(null);
  const [travellers, setTravellers] = useState({ adults: [], children: [], infants: [] });
  const [gstInfo, setGstInfo] = useState({ gstIn: "", nameOnGst: "", flat: "", street: "", area: "", pin: "", state: "", city: "" });
  const [contactDetails, setContactDetails] = useState({ emailId: "", countryCode: "", mobile: "", organizationType: "", gstNumber: "", gstName: "", emailOngst: "", phoneOnGst: "", addressOnGst: "" });
  const [ssrInfo, setSsrInfo] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [termsError, setTermsError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [airlineCode, setAirlineCode] = useState("");
  const [frequentFlyerNo, setFrequentFlyerNo] = useState("");
  const [airlineName, setAirlineName] = useState("");
  const [billingEntities, setBillingEntities] = useState([]);
  const [loadingBillingEntities, setLoadingBillingEntities] = useState(false);
  const [customField, setCustomField] = useState({ ref1: "", ref2: "", ref3: "", });

  const [searchParams, setSearchParams] = useState(null);
  const ChangeContactDetails = (e) => {
    const { name, value } = e.target;
    setContactDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleCustomFieldChange = (e) => {
    const { name, value } = e.target;

    setCustomField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [activeSegment, setActiveSegment] = useState(null);
  const [organizationsDetails, setOrganizationsDetails] = useState({
    billTo: "",
    companyType: "",
    companyName: "",
    companyId: "",
    cashBalance: 0,
    userEmailId: "",
    billingOptions: []
  });

  const [activeSegmentKey, setActiveSegmentKey] = useState(null);
  const [seatSelections, setSeatSelections] = useState({});

  const seatSummary = useMemo(() => {
    let seatCount = 0;
    let seatTotal = 0;

    Object.values(seatSelections || {}).forEach(segment => {
      Object.values(segment).forEach(paxGroup => {
        Object.values(paxGroup).forEach(seat => {
          if (seat?.seatCode) {
            seatCount++;
            seatTotal += Number(seat.price || 0);
          }
        });
      });
    });

    return { seatCount, seatTotal };
  }, [seatSelections]);
  // Baggage



  //Automatically call API when params are available
  useEffect(() => {
    if (referenceNo && clientCode && key) {
      fetchFlightData(referenceNo, clientCode, key);
      //fetchOrganizationsType(userName);
    } else {
      console.warn("Missing query parameters");
    }
  }, [referenceNo, clientCode, key]);

  const fetchFlightData = async (referenceNo, clientCode, key) => {
    try {
      setLoading(true);
      setError("");

      const params = {
        ReferenceNo: referenceNo,
        ClientCode: clientCode,
        Key: key,
      };
      setSearchParams(params)

      const response = await RetrieveSelectedFlight(params);
      
      const tripType = response?.data?.flightAvailibilies?.[0]?.trip;
      setTravelType(tripType === 1 ? "Domestic" : tripType === 2 ? "International" : "");

      //For Emulate
      const corporateCode = localStorage.getItem("selectedCorporateCode");
      const userId = localStorage.getItem("selectedUserId");

         const username = userId || userName;
      const _airlineCode = response.data.flightAvailibilies?.[0]?.validatingCarrier;
      const frequentFlyersResponse = await GetFrequentFlyersNoByAirline(username, _airlineCode);

      const agentDetailsResponse = await RetrieveCorporateDetails(userName, corporateCode, userId);
      //console.log("RetrieveSelectedFlight:", response.data);
      //console.log("CorporateDetails:", agentDetailsResponse);

      setIsSeatRequired(response.data.flightAvailibilies?.[0]?.conditions?.isSeatRequired);
      setIsBaggageRequired(response.data.flightAvailibilies?.[0]?.conditions?.isBaggageRequired);
      setIsMealRequired(response.data.flightAvailibilies?.[0]?.conditions?.isMealRequired);

      // const OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
      // const RF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 2) || [];
      // const OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
      // const RF = response.data?.flightAvailibilies?.[1]?.segments?.filter(t => t.flightCount === 1) || [];
      let OF = [];
      let RF = [];
      if (response.data?.flightAvailibilies?.[0]?.trip === 2 && response.data?.flightAvailibilies?.[0]?.tripType === 2) {
        OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
        RF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 2) || [];
      }
      else {
        OF = response.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
        RF = response.data?.flightAvailibilies?.[1]?.segments?.filter(t => t.flightCount === 1) || [];
      }
      setOF(OF);
      setRF(RF);

      //console.log("OF lenght:", OF.length);
      //console.log("OF:", OF);
      //console.log("RF:", RF);
      //console.log("RF length:", RF.length);

      let TotalBFare = 0;
      let TotalFare = 0;
      if (response.data && response.data.flightAvailibilies) {
        response.data.flightAvailibilies.forEach(item => {
          TotalBFare += parseFloat(item.fareDetails.totalBaseFare || 0);
          TotalFare += parseFloat(item.fareDetails.totalFare || 0);
        });
      }
      setTotalBFare(TotalBFare);
      setTotalFare(TotalFare);

      setFlightAvailibilies(response.data.flightAvailibilies);
      setAgencyDetails(agentDetailsResponse.data);

      const phone = agentDetailsResponse.data.corporateDetails?.phoneNumber || "";
      let countryCode = "91";
      let mobile = "";

      if (phone.includes(" ")) {
        [countryCode, mobile] = phone.split(" ");
      } else {
        mobile = phone;
      }
      setContactDetails({
        emailId: agentDetailsResponse.data.corporateDetails?.email || "",
        countryCode,
        mobile,
        organizationType: agentDetailsResponse.data.corporateDetails?.companyType || "",
        gstNumber: agentDetailsResponse.data.corporateDetails?.gstNumber || "",
        gstName: agentDetailsResponse.data.corporateDetails?.gstName || "",
        emailOngst: agentDetailsResponse.data.corporateDetails?.gstEmail || "",
        phoneOnGst: agentDetailsResponse.data.corporateDetails?.gstContactNumber || "",
        addressOnGst: agentDetailsResponse.data.corporateDetails?.gstAddress || "",
      });

      const firstName = agentDetailsResponse.data.corporateDetails?.firstName;
      const lastName = agentDetailsResponse.data.corporateDetails?.lastName;
      const airlineCode = frequentFlyersResponse?.airlineCode;
      const airlineName = frequentFlyersResponse?.airlineName;
      const frequentFlyerNo = frequentFlyersResponse?.frequentFlyerNo;

      setFirstName(firstName);
      setLastName(lastName);
      setAirlineCode(airlineCode);
      setAirlineName(airlineName);
      setFrequentFlyerNo(frequentFlyerNo);

      const OB = [...response.data.flightAvailibilies];
      ////console.log("OB:", OB[0].adult);
      setPaxCount(OB);

      let adultTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "ADT") {
              adultTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setAdultTotalBaseFare(adultTotalBaseFare)

      let childTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "CHD") {
              childTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setChildTotalBaseFare(childTotalBaseFare)

      let infantTotalBaseFare = 0;
      if (response.data.flightAvailibilies && response.data.flightAvailibilies.length > 0) {
        response.data.flightAvailibilies.forEach((flight) => {
          flight.fareDetails.paxFareDetails.forEach((pax) => {
            if (pax.paxType === "INFT" || pax.paxType === "INF") {
              infantTotalBaseFare += Number(pax.paxBaseFare);
            }
          });
        });
      }
      setInfantTotalBaseFare(infantTotalBaseFare)

    } catch (err) {
      //console.error(" Error fetching flight data:", err);
      setError("Failed to load flight details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrganizationsType = async (userName) => {
    try {
      const response = await GetOrganizationsType(userName);
      //console.log("response.data", response.data);

      const agency = response.data?.agencyDetails;

      if (!agency) return;

      const billingOptions = [
        {
          text: agency.companyType === "LegalEntity"
            ? "Legal Entity"
            : agency.companyType,      // Organization / Company / Legal Entity
          value: agency.companyId      // BE010000
        }
      ];

      // //console.log("Agency username:", agency?.userName);
      // setContactDetails(prev => ({
      //   ...prev,
      //   emailId: agency.userName
      // }));

      setOrganizationsDetails(prev => ({
        ...prev,
        companyType: agency.companyType,
        companyId: agency.companyId,
        cashBalance: agency.cashBalance,
        userEmailId: agency.userName,
        billingOptions,
        billTo: agency.companyId
      }));
    } catch (err) {
      setError("Failed to load organization details. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const ChangeBillingAddress = (e) => {
    setOrganizationsDetails(prev => ({
      ...prev,
      billTo: e.target.value
    }));
  };


  const nextStep = async () => {
    const { isValid, firstErrorField } = validateTravellers();

    if (!isValid && firstErrorField) {
      const { type, index, field } = firstErrorField;
      const inputName =
        type === "adult" || type === "child" || type === "infant"
          ? `${type === "adult" ? "adults" : type === "child" ? "children" : "infants"}[${index}].${field}`
          : null;

      if (inputName) {
        const fieldElement = document.querySelector(`[name="${inputName}"]`);
        if (fieldElement) {
          fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          fieldElement.focus();
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      return;
    }

    if (step === 1) {
      const result = await CheckDuplicateUser();
      console.log("CheckDuplicateUser log:", result);
      // debugger;
      //alert(result?.data?.message);

      if (result?.data?.status === true) {
        //alert(result?.data?.message);
        setDuplicateMessage(result.data.message);
        setDuplicateReferenceNo(result.data.referenceNo.trim());
        setDuplicateTrackId(result.data.trackId.trim());

        const modal = new window.bootstrap.Modal(
          document.getElementById("duplicateBookingModal")
        );
        modal.show();
        return;
      }
    }
    // Continue to next step
    setStep(step + 1);
  };

  const ContinueBooking = () => {
    setStep(step + 1);
  }

  const CheckDuplicateUser = async () => {
    //travellers, flightAvailibilies
    const req = {
      ReferenceNo: referenceNo,
      ProductType: "Flight",
      Passenger: travellers?.adults?.[0],
      // Segment: flightAvailibilies.origin + "-" + flightAvailibilies.destination,
      // TravelDate: flightAvailibilies.segments[0].departDateTime,
      // Supplier: flightAvailibilies.sCode,
      // FlightNumber: flightAvailibilies?.segments?.map(x => x.flightNumber).filter(Boolean).join(",") || "",
      // Airline: flightAvailibilies.validatingCarrier,
      // NoOfPax: (flightAvailibilies?.adult || 0) + (flightAvailibilies?.child || 0) + (flightAvailibilies?.infant || 0),
    };

    const Res = await CheckDuplicateBooking(req);
    debugger;
    return Res;
  };

  const prevStep = () => setStep((prev) => prev - 1);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const HandleGSTDetails = (e) => {
  //   setGstInfo({ ...formData, [e.target.name]: e.target.value });
  // };

  const HandleGSTDetails = (e) => {
    const { name, value } = e.target;
    setGstInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleTravellerChange = (type, index, field, value) => {
    setTravellers(prev => {
      const updatedType = [...prev[type]];
      updatedType[index] = { ...updatedType[index], [field]: value };
      return { ...prev, [type]: updatedType };
    });

    // remove error when typing
    setError(prev => ({
      ...prev,
      [`${type}_${index}_${field}`]: ""
    }));
  };

  useEffect(() => {
    if (!firstName && !lastName) return;
    setTravellers(prev => {
      const adults = [...prev.adults];

      // ensure first adult exists
      if (!adults[0]) {
        adults[0] = {};
      }

      adults[0] = {
        ...adults[0],
        firstName: adults[0].firstName || firstName,
        lastName: adults[0].lastName || lastName,
        airline: adults[0].airline || airlineCode,
        frequentFlyerNo: adults[0].frequentFlyerNo || frequentFlyerNo,
      };

      return { ...prev, adults };
    });
  }, [firstName, lastName]);

  //const hasCorporateDetailsFetched = useRef(false);
  useEffect(() => {
    //if (hasCorporateDetailsFetched.current) return;

    //hasCorporateDetailsFetched.current = true;
    fetchCorporateDetails();
  }, [userName]);

  const fetchCorporateDetails = async () => {
    try {
      setLoadingBillingEntities(true);
      const res = await GetCorporateDetailsForBilling(userName);
      setBillingEntities(res || []);

      const corporateCode = localStorage.getItem("selectedCorporateCode");
      if (corporateCode) {
        setOrganizationsDetails(prev => ({
          ...prev,
          billTo: corporateCode
        }));
      }

    } catch (error) {
      console.error("Error fetching corporate details", error);
    } finally {
      setLoadingBillingEntities(false);
    }
  };

  //ChangeBillingDetails const corporateCode = localStorage.getItem("selectedCorporateCode");
  const ChangeBillingDetails = (e) => {
    setOrganizationsDetails(prev => ({
      ...prev,
      //billTo: e.target.value
      billTo: e
    }));
  };


  /* ---------------- validateTravellers ---------------- */
  const validateTravellers = () => {
    let newErrors = {};
    let firstErrorField = null;

    /* ---------------- COMMON HELPERS ---------------- */

    const isEmpty = (value) => {
      if (value === null || value === undefined) return true;
      if (value instanceof Date) return false;
      //if (typeof value === "object") return true;
      if (typeof value === "object") return false;
      if (value === 0) return false;
      if (value.toString().trim() === "") return true;
      if (value.toString().trim().toLowerCase() === "select") return true;
      return false;
    };

    const isValidName = (value) => {
      const regex = /^[A-Za-z ]{2,50}$/;
      return regex.test(value?.trim());
    };

    const isValidGSTIN = (value) => {
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      return gstRegex.test(value);
    };

    const isValidEmail = (value) => {
      const emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(value);
    };

    // const isPhoneNumber = (value) => {
    //   const phoneRegex = /^(\+91[-\s]?)?[6-9]\d{9}$/;
    //   return phoneRegex.test(value);
    // };

    const isPhoneNumber = (value) => {
      const phoneRegex = /^((\+91|91)?[6-9]\d{9}|(\+971|971)?5\d{8})$/;
      return phoneRegex.test(value.replace(/\s|-/g, ""));
    };

    /* ---------------- TRAVELLER CHECK ---------------- */

    const checkTraveller = (type, index, field, label, value, isNameField = false) => {
      const key = `${type}_${index}_${field}`;

      if (isEmpty(value)) {
        newErrors[key] = `${label} is required`;
        if (!firstErrorField) firstErrorField = { type, index, field };
      } else if (isNameField && !isValidName(value)) {
        newErrors[key] = `${label} must be A–Z only and 2–50 characters`;
        if (!firstErrorField) firstErrorField = { type, index, field };
      }
    };

    // const validateType = (list, typeName) => {
    //   if (!Array.isArray(list) || list.length === 0) {
    //     newErrors[`${typeName}_empty`] = `${typeName.toUpperCase()} details are required`;
    //     if (!firstErrorField)
    //       firstErrorField = { type: typeName, index: 0, field: "title" };
    //     return;
    //   }

    //   list.forEach((t = {}, i) => {
    const validateType = (list, typeName, count) => {
      for (let i = 0; i < count; i++) {
        const t = list?.[i] || {};
        checkTraveller(typeName, i, "title", "Title", t.title);
        checkTraveller(typeName, i, "firstName", "First Name", t.firstName, true);
        checkTraveller(typeName, i, "lastName", "Last Name", t.lastName, true);

        if (
          (typeName === "adult" && flightAvailibilies?.[0]?.conditions?.dob?.adobr) ||
          (typeName === "child" && flightAvailibilies?.[0]?.conditions?.dob?.cdobr) ||
          (typeName === "infant" && flightAvailibilies?.[0]?.conditions?.dob?.idobr)
        ) {
          checkTraveller(typeName, i, "dob", "Date of Birth", t.dob);
        }



        if ("passportNo" in t) {
          checkTraveller(typeName, i, "passportNo", "Passport No", t.passportNo);
          checkTraveller(typeName, i, "issuingCountry", "Issuing Country", t.issuingCountry);
          checkTraveller(typeName, i, "nationality", "Nationality", t.nationality);
          //checkTraveller(typeName, i, "issueDate", "Issue Date", t.issueDate);
          checkTraveller(typeName, i, "expiryDate", "Expiry Date", t.expiryDate);
        }

        if (t.saveInfo === true) {
          checkTraveller(typeName, i, "userName", "User Name", t.userName);
        }
      }//);
    };

    /* ---------------- TRAVELLER VALIDATION ---------------- */

    // const adultList = travellers?.adults || [];
    // if (adultList.length === 0) {
    //   newErrors["adult_empty"] = "Passenger Details required";
    //   firstErrorField ??= { type: "adult", index: 0, field: "title" };
    // } else {
    //   validateType(adultList, "adult");
    // }
    // if (flightAvailibilies?.[0]?.child > 0) {
    //   validateType(travellers?.children || [], "child");
    // }
    // if (flightAvailibilies?.[0]?.infant > 0) {
    //   validateType(travellers?.infants || [], "infant");
    // }
    const adultCount = flightAvailibilies?.[0]?.adult || 0;
    const childCount = flightAvailibilies?.[0]?.child || 0;
    const infantCount = flightAvailibilies?.[0]?.infant || 0;

    validateType(travellers?.adults, "adult", adultCount);
    if (childCount > 0) {
      validateType(travellers?.children, "child", childCount);
    }
    if (infantCount > 0) {
      validateType(travellers?.infants, "infant", infantCount);
    }


    /* ---------------- GST VALIDATION (FIXED) ---------------- */

    const gstIn = contactDetails?.gstNumber?.trim();
    const nameOnGst = contactDetails?.gstName?.trim();
    const emailOngst = contactDetails?.emailOngst?.trim();
    const phoneOnGst = contactDetails?.phoneOnGst?.trim();
    const addressOnGst = contactDetails?.addressOnGst?.trim();
    const emailId = contactDetails?.emailId?.trim();
    const mobile = contactDetails?.mobile?.trim();

    //contact Email And No.
    if (isEmpty(emailId)) {
      newErrors.emailId = "Email Address is required";
      firstErrorField ??= "emailId";
    } else if (!isValidEmail(emailId)) {
      newErrors.emailId =
        "Enter a valid Email address";
      firstErrorField ??= "emailId";
    }
    if (isEmpty(mobile)) {
      newErrors.mobile = "Phone Number is required";
      firstErrorField ??= "mobile";
    } else if (!isPhoneNumber(mobile)) {
      newErrors.mobile =
        "Enter a valid Phone Number";
      firstErrorField ??= "mobile";
    }


    // isGSTMandatory 
    if (flightAvailibilies?.[0]?.isGSTMandatory == true) {
      if (isEmpty(gstIn)) {
        newErrors.gstIn = "GSTIN is required";
        firstErrorField ??= "gstIn";
        //setFirstError("gst", 0, "gstIn");
      } else if (!isValidGSTIN(gstIn)) {
        newErrors.gstIn = "Enter a valid 15-digit GSTIN";
        firstErrorField ??= "gstIn";
      }

      if (isEmpty(nameOnGst)) {
        newErrors.nameOnGst = "Name on GST is required";
        firstErrorField ??= "nameOnGst";
      } else if (!isValidName(nameOnGst)) {
        newErrors.nameOnGst =
          "Name on GST must be A–Z only and 2–50 characters";
        firstErrorField ??= "nameOnGst";
      }

      if (isEmpty(emailOngst)) {
        newErrors.emailOngst = "Email Address on GST is required";
        firstErrorField ??= "emailOngst";
      } else if (!isValidEmail(emailOngst)) {
        newErrors.emailOngst =
          "Enter a valid Email address";
        firstErrorField ??= "emailOngst";
      }
      if (isEmpty(phoneOnGst)) {
        newErrors.phoneOnGst = "Phone on GST is required";
        firstErrorField ??= "phoneOnGst";
      } else if (!isPhoneNumber(phoneOnGst)) {
        newErrors.phoneOnGst =
          "Enter a valid Phone Number";
        firstErrorField ??= "phoneOnGst";
      }
      if (isEmpty(addressOnGst)) {
        newErrors.addressOnGst = "Address on GST is required";
        firstErrorField ??= "addressOnGst";
      }
      // else if (!isValidName(addressOnGst)) {
      //   newErrors.addressOnGst =
      //     "Address on GST must be A–Z only and 2–50 characters";
      //   firstErrorField ??= "addressOnGst";
      // }
    }

    // Seat Meal Bagges validation
    const totalPayingPax =
      (flightAvailibilies?.[0]?.adult || 0) +
      (flightAvailibilies?.[0]?.child || 0);

    const selectedSeatCount = Object.values(seatSelections || {}).reduce(
      (s, seg) =>
        s + Object.values(seg).reduce(
          (p, grp) => p + Object.values(grp).filter(x => x?.seatCode).length,
          0
        ),
      0
    );
    const selectedBaggageCount = Object.values(selectedBaggage || {}).length;
    const selectedMealCount = Object.values(selectedMeal || {}).length;

    if (isSeatRequired && selectedSeatCount < totalPayingPax) {
      newErrors.seatRequired =
        `Please select seats for all ${totalPayingPax} passenger(s). ` +
        `Selected: ${selectedSeatCount}`;
      firstErrorField ??= "seatRequired";
    }

    if (isMealRequired && selectedMealCount < totalPayingPax) {
      newErrors.mealRequired =
        `Please select meal for all ${totalPayingPax} passenger(s). ` +
        `Selected: ${selectedMealCount}`;
      firstErrorField ??= "mealRequired";
    }

    if (isBaggageRequired && selectedBaggageCount < totalPayingPax) {
      newErrors.baggageRequired =
        `Please select baggage for all ${totalPayingPax} passenger(s). ` +
        `Selected: ${selectedBaggageCount}`;
      firstErrorField ??= "baggageRequired";
    }

    /* ---------------- BILLING VALIDATION ---------------- */
    const isBillingRequired = ["TMC Operations", "TMC Manager"].some(
      (role) => roles?.includes(role)
    );

    if (isBillingRequired && isEmpty(organizationsDetails?.billTo)) {
      newErrors.billTo = "Billing Details is required";
      firstErrorField ??= "billTo";
    }

    setError(newErrors);

    return {
      isValid: Object.keys(newErrors).length === 0,
      firstErrorField,
    };
  };


  //----------------TravelPolicies----------------------

  const [showMealOption, setShowMealOption] = useState(true);
  const [showSeatOption, setShowSeatOption] = useState(true);
  const [showExtraBaggage, setShowExtraBaggageOption] = useState(true);

  const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
  const emulateUserCorporateCode = emulateCorporateCode || corporateId;
  const CorpTravellerUserId = localStorage.getItem("selectedUserId");
  const CorpTraveller = CorpTravellerUserId ?? userName;
  useEffect(() => {
    if (!userName || !travelType || !emulateUserCorporateCode) return;
    const getTravelPolicies = async () => {
      try {
        const response = await TravelPolicies({
          UserName: CorpTraveller,
          ProductType: "Flight",
          CorporateCode: emulateUserCorporateCode,
          TravelType: travelType
        });

        setPolicies(response);
        setShowExtraBaggageOption(response?.approvalPolicy?.result?.travelPolicies?.[0]?.extraBaggage ?? true);
        setShowMealOption(response?.approvalPolicy?.result?.travelPolicies?.[0]?.meal ?? true);
        setShowSeatOption(response?.approvalPolicy?.result?.travelPolicies?.[0]?.seat ?? true);

        //console.log("getTravelPolicies", response);
      } catch (error) {
        console.error(error);
      }
    };

    getTravelPolicies();
  }, [userName, emulateUserCorporateCode, travelType]);

  useEffect(() => {
    if (!userName || !travelType || !emulateUserCorporateCode) return;
    const getApprovalPolicies = async () => {
      try {
        const response = await ApprovalPolicy({
          UserName: CorpTraveller,
          ProductType: "Flight",
          CorporateCode: emulateUserCorporateCode,
          TravelType: travelType
        });

        setApprovalPolicies(response);

        //console.log("getApprovalPolicies", response);
      } catch (error) {
        console.error(error);
      }
    };

    getApprovalPolicies();
  }, [userName, emulateUserCorporateCode, travelType]);


  useEffect(() => {
    const policyStatus = flightAvailibilies?.[0]?.policyStatus;
    let policy = approvalPolicies?.approvalPolicy?.result?.find(
      item => item.policyStatus === policyStatus
    );

    if (!policy) {
      policy = approvalPolicies?.approvalPolicy?.result?.find(
        item => item.policyStatus === "All"
      );
    }

    setPolicyData(policy || null);
  }, [approvalPolicies, flightAvailibilies]);

  //---------------------------------------

  // Special Service Start

  const [baggageList, setBaggageList] = useState([]);
  const [selectedBaggage, setSelectedBaggage] = useState("");
  const [baggageAmount, setBaggageAmount] = useState(0);
  // const [baggageTotal, setBaggageTotal] = useState(0);

  const [mealList, setMealList] = useState([]);
  const [selectedMeal, setSelectedMeal] = useState("");
  const [mealAmount, setMealAmount] = useState(0);

  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    callSpecialService();
  }, [referenceNo, key]);

  const [ssrResult, setSsrResult] = useState([]);

  const callSpecialService = async () => {
    try {
      const requestBody = {
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
      };

      const response = await SpecialService(requestBody);

      //  STORE FULL RESULT
      setSsrResult(response?.result || []);
      //console.log("SsrResult:", response?.result);

    } catch (error) {
      console.error("Failed to load SpecialService", error);
    }
  };

  const ChangeAddBaggage = (
    item,
    paxIndex,
    paxType,
    sectorKey,
    trackID
  ) => {

    const uniqueKey = `${sectorKey}_${paxType}_${paxIndex}_${item?.code}`;

    setSelectedBaggage((prev) => {
      let updated = { ...prev };

      // REMOVE if already selected
      if (updated[uniqueKey]) {
        delete updated[uniqueKey];
        return updated;
      }

      // Remove ONLY same pax + same sector
      Object.keys(updated).forEach((k) => {
        if (k.startsWith(`${sectorKey}_${paxType}_${paxIndex}_`)) {
          delete updated[k];
        }
      });

      updated[uniqueKey] = {
        ...item,
        paxIndex,
        paxType,
        sectorKey,
        trackID
      };

      return updated;
    });
  };

  const ChangeAddMeal = (
    item,
    paxIndex,
    paxType,
    sectorKey,
    trackID
  ) => {
    const uniqueKey = `${sectorKey}_${paxType}_${paxIndex}_${item?.code}`;

    setSelectedMeal((prev) => {
      let updated = { ...prev };

      if (updated[uniqueKey]) {
        delete updated[uniqueKey];
        return updated;
      }

      Object.keys(updated).forEach((k) => {
        if (k.startsWith(`${sectorKey}_${paxType}_${paxIndex}_`)) {
          delete updated[k];
        }
      });

      updated[uniqueKey] = {
        ...item,
        paxIndex,
        paxType,
        sectorKey,
        trackID
      };

      return updated;
    });
  };

  const baggageItems = Object.values(selectedBaggage || {});
  const baggageCount = baggageItems.length;

  const baggageTotal = baggageItems.reduce(
    (sum, item) => sum + Number(item?.price || 0),
    0
  );

  // Meal
  const mealItems = Object.values(selectedMeal || {});
  const mealCount = mealItems.length;

  const mealTotal = mealItems.reduce(
    (sum, item) => sum + Number(item?.price || 0),
    0
  );



  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedMealAmount, setSelectedMealAmount] = useState({
    ADULT: [],
    CHILD: [],
    INFANT: []
  });
  const [selectedBaggageAmount, setSelectedBaggageAmount] = useState({
    ADULT: [],
    CHILD: [],
    INFANT: []
  });

  if (!flightAvailibilies || !flightAvailibilies[0]) {
    return <div><p class="text-center load"><span class="loader"></span></p>
    </div>;
  }
  const availability = flightAvailibilies?.[0] || null;

  const filteredMealList = mealList || [];
  const filteredBaggageList = baggageList || [];


  // Special Service End
  //console.log("selectedMeal", selectedMeal);
  //console.log("selectedBaggage", selectedBaggage);
  //console.log("seatSelections", seatSelections);


  const handlePaymentSubmit = async () => {
    setPaymentError("");
    setTermsError("");
    setSuccess("");

    // Payment Method Validation
    if (!paymentMethod) {
      setPaymentError("Please select a payment method before continuing.");
      return;
    }

    // Agency Credit Balance Validation
    if (paymentMethod === "AgencyWallet") {
      const balance = parseFloat(agencyDetails?.corporateDetails?.cashBalance || 0);
      if (balance <= 0) {
        setPaymentError("Insufficient agency balance for payment.");
        return;
      }
    }

    if (paymentMethod === "AgencyCreditLimit") {
      const balance = parseFloat(agencyDetails?.corporateDetails?.cashBalance || 0) + parseFloat(agencyDetails?.corporateDetails?.creditLimit || 0);
      if (balance <= 0) {
        setPaymentError("Insufficient agency Credit Limit for payment.");
        return;
      }
    }

    // Terms Checkbox Validation
    if (!acceptedTerms) {
      setTermsError("Please accept the Terms & Conditions before continuing.");
      return;
    }

    try {
      setLoading(true);
      //const response = await AddPassengerDetails(requestBody);
      const response = await AddPassengerDetails({
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
        contactDetails,
        travellers,
        ssrInfo,
        pricing,
        userName,
        seatSelections,
        selectedMeal,
        selectedBaggage,
        companyMarkup,
        customField
      });
      //console.log(response);

      if (travellers.adults?.some(x => x.saveInfo) || travellers.child?.some(x => x.saveInfo) || travellers.infant?.some(x => x.saveInfo)) {
        try {
          const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
          const userId = emulateCorporateCode || corporateId;

          const ProfileResponse = await CreateCorporateTravellerProfile({
            contactDetails,
            travellers,
            userName,
            corporateCode: userId,
            product: "Flight"
          });
          //console.log("ProfileResponse", ProfileResponse);
        } catch (profileError) {
          console.error("Profile creation failed:", profileError);
        }
      }

      if (response?.status === "Success") {
        setSuccess("Pax saved successfully!");

        const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
        const userId = emulateCorporateCode || corporateId;
        //call here Api To collect Payment 
        const response = await CollectPayment({
          transactionID: referenceNo,
          referenceNo: referenceNo,
          corporateCode: userId,
          userId: userName,
          service: "Flight",
          sessionId: key,
          transactionType: "",
          remarks: "",
          totalAmount: totalFare,
          creditLimit: true,
          status: "",
          paymentMode: {
            paymentModeType: organizationsDetails.companyType,
            cardType: "",
            productType: "",
            pgProvider: paymentMethod
          },
          //paymentMode: paymentMethod,
          ipAddress: "",
        });
        //console.log("webPaymentLink", response.formHtml);
        if (response?.success === true && response?.message === "Payment form generated.") {
          window.open(response.formHtml, "_self");
          //window.open(response.formHtml, "_blank");
        }

        else if (response?.success === true) {
          setSuccess("Payment successful!!");
          const response = await FlightBooking({
            clientCode: "BerryJourneys",
            userID: userName,
            key: key,
            referenceNo: referenceNo,
          });
          //if (response?.message === "Success") {
          navigate(`/thankyou?ReferenceNo=${referenceNo}`);
          //}

        } else {
          setPaymentError(response?.message || "Payment fail. Try again.");
        }
      } else {
        setPaymentError(response?.data?.message || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("Payment API Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const SubmitApprovalRequest = async () => {
    setTermsError("");
    setSuccess("");

    try {
      setLoading(true);
      const response = await AddPassengerDetails({
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
        contactDetails,
        travellers,
        ssrInfo,
        pricing,
        userName,
        seatSelections,
        selectedMeal,
        selectedBaggage,
        companyMarkup,
        customField
      });
      //console.log(response);
      if (response?.status === "Success") {
        setSuccess("Pax saved successfully!");

        //call here Api To Approval Request
        const response = await ApprovalRequest({
          referenceNo: referenceNo,
          key: key,
          userId: userName,
          product: "Flight",
          level1ApproverType: policyData?.firstLevelApproval,
          level2ApproverType: policyData?.secondLevelApproval,
          level1CustomApprover: policyData?.firstLevelCustomApproval,
          level2CustomApprover: policyData?.secondLevelCustomApproval,

          //level1Approver: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.firstLevelApproval ==="Custom" ? approvalPolicies?.approvalPolicy?.result?.[0]?.firstLevelCustomApproval : approvalPolicies?.approvalPolicy?.result?.[0]?.firstLevelApproval,
          //level2Approver: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.secondLevelApproval ==="Custom" ? approvalPolicies?.approvalPolicy?.result?.[0]?.secondLevelCustomApproval : approvalPolicies?.approvalPolicy?.result?.[0]?.secondLevelApproval,
          // level1Approver: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.firstLevelApproval,
          // level2Approver: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.secondLevelApproval,
          // level1CustomApprover: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.firstLevelCustomApproval,
          // level2CustomApprover: approvalPolicies?.approvalPolicy?.result?.travelPolicies?.[0]?.secondLevelCustomApproval,
        });
        if (response?.success === true) {
          alert(response?.message);
          navigate(`/flight`);
        } else {
          setPaymentError(response?.message || "Approval Request fail. Try again.");
        }
      } else {
        setPaymentError(response?.data?.message || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("ApprovalRequest Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const SendPaymentLink = async () => {
    setTermsError("");
    setSuccess("");

    try {
      setLoading(true);
      const response = await AddPassengerDetails({
        clientCode: "BerryJourneys",
        key: key,
        referenceNo: referenceNo,
        contactDetails,
        travellers,
        ssrInfo,
        pricing,
        userName
      });

      if (travellers.adults?.some(x => x.saveInfo) || travellers.child?.some(x => x.saveInfo) || travellers.infant?.some(x => x.saveInfo)) {
        try {
          const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
          const userId = emulateCorporateCode || corporateId;
          const ProfileResponse = await CreateCorporateTravellerProfile({
            contactDetails,
            travellers,
            userName,
            corporateCode: userId,
            product: "Flight"
          });
          //console.log("ProfileResponse", ProfileResponse);
        } catch (profileError) {
          console.error("Profile creation failed:", profileError);
        }
      }
      //console.log(response);
      if (response?.status === "Success") {
        setSuccess("Pax saved successfully!");

        //call here Api To send payment Link
        const response = await SendPaymentLinkMail({
          referenceNo: referenceNo,
          product: "Flight",
        });
        if (response?.success === true) {
          alert(response?.message);
          navigate(`/flight`);
        }
        else {
          setPaymentError(response?.message || "payment Link Send fail. Try again.");
        }
      } else {
        setPaymentError(response?.data?.message || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("Payment API Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const flightFareTotal = (flightAvailibilies || []).reduce((sum, x) => {
    const fare = x.fareDetails || {};

    return (
      sum +
      Number(fare.totalOtherTax || 0) +
      Number(fare.totalServiceTax || 0) +
      Number(fare.managementFee || 0) +
      Number(fare.baggageCharge || 0) +
      Number(fare.mealCharge || 0) +
      Number(fare.managementFeeTax || 0)
    );
  }, 0);
  const seatTotal = Object.values(seatSelections || {}).reduce(
    (segmentSum, segment) =>
      segmentSum +
      Object.values(segment).reduce(
        (paxTypeSum, paxGroup) =>
          paxTypeSum +
          Object.values(paxGroup).reduce(
            (seatSum, seat) => seatSum + Number(seat?.price || 0),
            0
          ),
        0
      ),
    0
  );

  const grandOtherTotal =
    Number(flightFareTotal || 0) +
    Number(baggageTotal || 0) +
    Number(mealTotal || 0) +
    Number(seatTotal || 0) +
    Number(companyMarkup || 0);

  const baseFareTotal =
    Number(adultTotalBaseFare || 0) +
    Number(childTotalBaseFare || 0) +
    Number(infantTotalBaseFare || 0);

  const finalGrandTotal =
    Number(totalBFare || 0) +
    Number(grandOtherTotal || 0);

  //const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
  let paymentButton = null;
  if ((roles === "TMC Operations" || roles === "TMC Manager") && emulateCorporateCode != null) {
    paymentButton = (
      <>
        <button className="btn btn-warning" onClick={SendPaymentLink}>
          Send Payment Link
        </button>
        <button className="btn btn-primary" onClick={handlePaymentSubmit}>
          Pay & Book
        </button>
      </>
    );
  } else {
    paymentButton = (
      <button className="btn btn-primary" onClick={handlePaymentSubmit}>
        Pay & Book
      </button>
    );
  }

  let ApprovalRequestButton = null;
  if ((roles === "Corporate Traveller") && (policyData && policyData.isApprovalRequired)) {
    ApprovalRequestButton = (
      <button className="btn btn-primary" onClick={SubmitApprovalRequest}>
        Request For Approval
      </button>
    );
  }
  else {
    ApprovalRequestButton = (
      <button
        className="btn btn-primary"
        onClick={() => {
          nextStep();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        Continue
      </button>
    );
  }

  const billingEntitiesOptions = billingEntities.map(item => ({
    value: item.corporateCode,
    label: `${item.corporateName} (${item.corporateCode})`
  }));
  const airlineOptions = airlines.map(item => ({
    value: item.airLineCode,
    label: `${item.airLineName}`
  }));

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <Header></Header>
      <section className='Booking_flight'>
        <div className='container_box'>
          <div className='row'>
            <div className='col-md-9'>
              <div className='box_shadow'>
                <div className="steps mb-4 d-flex justify-content-start">
                  <span className={step === 1 ? "active Payment" : "Payment"}>Travellers' Details</span>
                  <span className={step === 2 ? "active Payment" : "Payment"}>Confirm Booking</span>
                  <span className={step === 3 ? "active Payment" : "Payment"}>Payment</span>
                </div>

                {/* Step 1 */}
                {/* {loading && (
                  <p class="text-center load"><span class="loader"></span></p>
                )} */}
                {step === 1 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Review Your Booking</h4>
                      {flightAvailibilies && flightAvailibilies.length > 0 && (
                        flightAvailibilies[0].TripType === "MultiCity" ? (
                          <>
                            <div className="row">
                              <div className="col-lg-12">
                                <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                <div className="row">
                                  <div className="col-md-2">
                                    <div className="flight_img">
                                      <img
                                        className="img_icon"
                                        src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                        alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                        onError={(e) => {
                                          e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                        }}
                                      />                                    </div>
                                    <div className="name_code">
                                      <span>IX - 1194</span>
                                      <span>Air India Express</span>
                                    </div>
                                  </div>
                                  <div className="col-md-10">
                                    <div className="row">
                                      <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                      <div className="col-md-3">
                                        <div className="timer">
                                          <p>Delhi</p>
                                          <h4>DEL <span>|</span> 23:30</h4>
                                          <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                          <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>02:15  |  0 STOP </p>
                                          <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                          <p className="">
                                            <span>Economy </span>
                                            <span>Partial Refundable</span>
                                          </p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="timer">
                                          <p>Mumbai</p>
                                          <h4>BOM <span>|</span> 01:45</h4>
                                          <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                          <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="baggage">
                                          <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                          <p>Check-in :<strong>15 Kg / person</strong></p>
                                          <p>Cabin :<strong>07 Kg/ person</strong></p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {oF && oF.length > 0 && (
                              <>
                                <div className="row">
                                  <p className="departure d-flex justify-content-between align-items-center">
                                    <span><i className="fa fa-plane"></i> Departure</span>
                                    {/* <span>Total Duration : {flightAvailibilies?.[0]?.totalDuration}</span> */}
                                    <span>
                                     <b> {oF?.[0]?.departAirportCode} - {oF?.[oF.length - 1]?.arrivalAirportCode}  { }  </b> 
                                      (Stop: {oF.length - 1}) { }
                                      {flightAvailibilies?.[0]?.fareDetails?.cabinClass} { "|| " }
                                      {flightAvailibilies?.[0]?.fareType}
                                    </span>
                                    <span>
                                      Total Duration: {(() => {
                                        const [hours, minutes] = (flightAvailibilies?.[0]?.totalDuration || "0:0")
                                          .split(":")
                                          .map(Number);

                                        return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m` : ""}`.trim();
                                      })()}
                                    </span>
                                  </p>
                                  {oF.map((segment, index) => (
                                    <div className="col-lg-12" key={index}>
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="flight_img">
                                            {/* <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" /> */}
                                            <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                          </div>
                                          <div className="name_code">
                                            <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                            <span>{segment.airLineName}</span>
                                          </div>
                                        </div>
                                        <div className="col-md-10">
                                          <div className="row">
                                            <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.departCityName}</p>
                                                <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="deruation">
                                                {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                  <p>{segment.duration} | {segment.viaSector}</p>
                                                ) : (
                                                  <p>{segment.duration} </p>
                                                )}

                                                <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                <p className="">
                                                  {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                    <span>{segment.travelClass}</span>
                                                  )}
                                                  {/* {flightAvailibilies?.[0]?.fareDetails?.cabinClass} */}

                                                  {flightAvailibilies[0].isRefundable ? (
                                                    <span>Partially Refundable</span>
                                                  ) : (
                                                    <span>Non-Refundable</span>
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.arrivalCityName}</p>
                                                <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>{segment.baggageDetails[0].baggage} / person</strong></p>
                                                  <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} / person</strong></p>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          {segment.layoverMessage && (
                                            <div className="col-lg-12">
                                              <div className="alert alert-info py-2 mb-0 mt-2" role="alert">
                                                <i className="fa fa-info-circle"></i> {segment.layoverMessage}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}


                                </div>
                              </>
                            )}
                            {rF && rF.length > 0 && (
                              <>
                                <div className="row">
                                  <p className="departure d-flex justify-content-between align-items-center">
                                    <span><i className="fa fa-plane"></i> Return</span>
                                    {/* <span>Total Duration : {flightAvailibilies?.[0]?.totalDurationReturn}</span> */}
                                     <span>
                                      <b>{rF?.[0]?.departAirportCode} - {rF?.[oF.length - 1]?.arrivalAirportCode}  { }</b>   
                                      (Stop: {rF.length - 1}) { }
                                      {flightAvailibilies?.[0]?.fareDetails?.cabinClass} { "|| " }
                                      {flightAvailibilies?.[1]?.fareType || flightAvailibilies?.[0]?.fareType} 
                                    </span>
                                    <span>
                                      Total Duration: {(() => {
                                        const [hours, minutes] = (flightAvailibilies?.[1]?.totalDurationReturn || flightAvailibilies?.[0]?.totalDurationReturn || "0:0")
                                          .split(":")
                                          .map(Number);

                                        return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m` : ""}`.trim();
                                      })()}
                                    </span>
                                  </p>
                                  {/* <p className="departure"><i className="fa fa-plane"></i> Return</p> */}
                                  {rF.map((segment, index) => (
                                    <div className="col-lg-12" key={index}>
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="flight_img">
                                            <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                          </div>
                                          <div className="name_code">
                                            <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                            <span>{segment.airLineName}</span>
                                          </div>
                                        </div>
                                        <div className="col-md-10">
                                          <div className="row">
                                            <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.departCityName}</p>
                                                <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="deruation">
                                                {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                  <p>{segment.duration} | {segment.viaSector}</p>
                                                ) : (
                                                  <p>{segment.duration} </p>
                                                )}

                                                <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                <p className="">
                                                  {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                    <span>{segment.travelClass}</span>
                                                  )}
                                                  {/* {flightAvailibilies?.[0]?.fareDetails?.cabinClass} */}
                                                  <br></br>
                                                  {flightAvailibilies[0].isRefundable ? (
                                                    <span>Partially Refundable</span>
                                                  ) : (
                                                    <span>Non-Refundable</span>
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="timer">
                                                <p>{segment.arrivalCityName}</p>
                                                <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                  weekday: "short",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                  // hour: "2-digit",
                                                  // minute: "2-digit",
                                                  hour12: false
                                                })}</p>
                                                <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>{segment.baggageDetails[0].baggage} / person</strong></p>
                                                  <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} / person</strong></p>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {segment.layoverMessage && (
                                          <div className="col-lg-12">
                                            <div className="alert alert-info py-2 mb-0 mt-2" role="alert">
                                              <i className="fa fa-info-circle"></i> {segment.layoverMessage}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}

                          </>
                        )
                      )}

                      <h4 className="sub_heading">Enter Traveller Details</h4>
                      <div className="Traveller">
                        <h5>Contact Details</h5>
                        <div className="row">
                          <div className="col-md-5">
                            <div className="form-group">
                              <label className="">Email Address</label>
                              <input className={`form-control form-control-solid ${error?.emailId ? "is-invalid" : ""
                                }`} name="emailId" type="text" placeholder="."
                                // readOnly
                                //value={organizationsDetails.userEmailId}
                                value={contactDetails.emailId} //agencyDetails.corporateDetails.email
                                onChange={ChangeContactDetails}
                              />
                              {error?.emailId && (
                                <small className="text-danger">{error.emailId}</small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label className="required">Contact Number</label>
                              <div className="d-flex">
                                <div className="selct">
                                  <select className="form-select form-select-solid"
                                    name="countryCode"
                                    value={contactDetails.countryCode}
                                    onChange={ChangeContactDetails}
                                  >
                                    <option value="91">India (+91)</option>
                                    <option value="93">Afghanistan (+93)</option>
                                    <option value="355">Albania (+355)</option>
                                    <option value="213">Algeria (+213)</option>
                                    <option value="1 684">American Samoa (+1 684)</option>
                                    <option value="376">Andorra (+376)</option>
                                    <option value="244">Angola (+244)</option>
                                    <option value="1 264">Anguilla (+1 264)</option>
                                    <option value="672">Antarctica (+672)</option>
                                    <option value="1 268">Antigua and Barbuda (+1 268)</option>
                                    <option value="54">Argentina (+54)</option>
                                    <option value="374">Armenia (+374)</option>
                                    <option value="297">Aruba (+297)</option>
                                    <option value="61">Australia (+61)</option>
                                    <option value="43">Austria (+43)</option>
                                    <option value="994">Azerbaijan (+994)</option>
                                    <option value="1 242">Bahamas (+1 242)</option>
                                    <option value="973">Bahrain (+973)</option>
                                    <option value="880">Bangladesh (+880)</option>
                                    <option value="1 246">Barbados (+1 246)</option>
                                    <option value="375">Belarus (+375)</option>
                                    <option value="32">Belgium (+32)</option>
                                    <option value="501">Belize (+501)</option>
                                    <option value="229">Benin (+229)</option>
                                    <option value="1 441">Bermuda (+1 441)</option>
                                    <option value="975">Bhutan (+975)</option>
                                    <option value="591">Bolivia (+591)</option>
                                    <option value="387">Bosnia and Herzegovina (+387)</option>
                                    <option value="267">Botswana (+267)</option>
                                    <option value="55">Brazil (+55)</option>
                                    <option value="1 284">British Virgin Islands (+1 284)</option>
                                    <option value="673">Brunei (+673)</option>
                                    <option value="359">Bulgaria (+359)</option>
                                    <option value="226">Burkina Faso (+226)</option>
                                    <option value="95">Burma (Myanmar) (+95)</option>
                                    <option value="257">Burundi (+257)</option>
                                    <option value="855">Cambodia (+855)</option>
                                    <option value="237">Cameroon (+237)</option>
                                    <option value="1">Canada (+1)</option>
                                    <option value="238">Cape Verde (+238)</option>
                                    <option value="1 345">Cayman Islands (+1 345)</option>
                                    <option value="236">Central African Republic (+236)</option>
                                    <option value="235">Chad (+235)</option>
                                    <option value="56">Chile (+56)</option>
                                    <option value="86">China (+86)</option>
                                    <option value="61">Christmas Island (+61)</option>
                                    <option value="61">Cocos (Keeling) Islands (+61)</option>
                                    <option value="57">Colombia (+57)</option>
                                    <option value="269">Comoros (+269)</option>
                                    <option value="682">Cook Islands (+682)</option>
                                    <option value="506">Costa Rica (+506)</option>
                                    <option value="385">Croatia (+385)</option>
                                    <option value="53">Cuba (+53)</option>
                                    <option value="357">Cyprus (+357)</option>
                                    <option value="420">Czech Republic (+420)</option>
                                    <option value="243">Democratic Republic of the Congo (+243)</option>
                                    <option value="45">Denmark (+45)</option>
                                    <option value="253">Djibouti (+253)</option>
                                    <option value="1 767">Dominica (+1 767)</option>
                                    <option value="1 809">Dominican Republic (+1 809)</option>
                                    <option value="593">Ecuador (+593)</option>
                                    <option value="20">Egypt (+20)</option>
                                    <option value="503">El Salvador (+503)</option>
                                    <option value="240">Equatorial Guinea (+240)</option>
                                    <option value="291">Eritrea (+291)</option>
                                    <option value="372">Estonia (+372)</option>
                                    <option value="251">Ethiopia (+251)</option>
                                    <option value="500">Falkland Islands (+500)</option>
                                    <option value="298">Faroe Islands (+298)</option>
                                    <option value="679">Fiji (+679)</option>
                                    <option value="358">Finland (+358)</option>
                                    <option value="33">France (+33)</option>
                                    <option value="689">French Polynesia (+689)</option>
                                    <option value="241">Gabon (+241)</option>
                                    <option value="220">Gambia (+220)</option>
                                    <option value="970">Gaza Strip (+970)</option>
                                    <option value="995">Georgia (+995)</option>
                                    <option value="49">Germany (+49)</option>
                                    <option value="233">Ghana (+233)</option>
                                    <option value="350">Gibraltar (+350)</option>
                                    <option value="30">Greece (+30)</option>
                                    <option value="299">Greenland (+299)</option>
                                    <option value="1 473">Grenada (+1 473)</option>
                                    <option value="1 671">Guam (+1 671)</option>
                                    <option value="502">Guatemala (+502)</option>
                                    <option value="224">Guinea (+224)</option>
                                    <option value="245">Guinea-Bissau (+245)</option>
                                    <option value="592">Guyana (+592)</option>
                                    <option value="509">Haiti (+509)</option>
                                    <option value="39">Holy See (Vatican City) (+39)</option>
                                    <option value="504">Honduras (+504)</option>
                                    <option value="852">Hong Kong (+852)</option>
                                    <option value="36">Hungary (+36)</option>
                                    <option value="354">Iceland (+354)</option>
                                    {/* <option value="91">India (+91)</option> */}
                                    <option value="62">Indonesia (+62)</option>
                                    <option value="98">Iran (+98)</option>
                                    <option value="964">Iraq (+964)</option>
                                    <option value="353">Ireland (+353)</option>
                                    <option value="44">Isle of Man (+44)</option>
                                    <option value="972">Israel (+972)</option>
                                    <option value="39">Italy (+39)</option>
                                    <option value="225">Ivory Coast (+225)</option>
                                    <option value="1 876">Jamaica (+1 876)</option>
                                    <option value="81">Japan (+81)</option>
                                    <option value="962">Jordan (+962)</option>
                                    <option value="7">Kazakhstan (+7)</option>
                                    <option value="254">Kenya (+254)</option>
                                    <option value="686">Kiribati (+686)</option>
                                    <option value="381">Kosovo (+381)</option>
                                    <option value="965">Kuwait (+965)</option>
                                    <option value="996">Kyrgyzstan (+996)</option>
                                    <option value="856">Laos (+856)</option>
                                    <option value="371">Latvia (+371)</option>
                                    <option value="961">Lebanon (+961)</option>
                                    <option value="266">Lesotho (+266)</option>
                                    <option value="231">Liberia (+231)</option>
                                    <option value="218">Libya (+218)</option>
                                    <option value="423">Liechtenstein (+423)</option>
                                    <option value="370">Lithuania (+370)</option>
                                    <option value="352">Luxembourg (+352)</option>
                                    <option value="853">Macau (+853)</option>
                                    <option value="389">Macedonia (+389)</option>
                                    <option value="261">Madagascar (+261)</option>
                                    <option value="265">Malawi (+265)</option>
                                    <option value="60">Malaysia (+60)</option>
                                    <option value="960">Maldives (+960)</option>
                                    <option value="223">Mali (+223)</option>
                                    <option value="356">Malta (+356)</option>
                                    <option value="692">Marshall Islands (+692)</option>
                                    <option value="222">Mauritania (+222)</option>
                                    <option value="230">Mauritius (+230)</option>
                                    <option value="262">Mayotte (+262)</option>
                                    <option value="52">Mexico (+52)</option>
                                    <option value="691">Micronesia (+691)</option>
                                    <option value="373">Moldova (+373)</option>
                                    <option value="377">Monaco (+377)</option>
                                    <option value="976">Mongolia (+976)</option>
                                    <option value="382">Montenegro (+382)</option>
                                    <option value="1 664">Montserrat (+1 664)</option>
                                    <option value="212">Morocco (+212)</option>
                                    <option value="258">Mozambique (+258)</option>
                                    <option value="264">Namibia (+264)</option>
                                    <option value="674">Nauru (+674)</option>
                                    <option value="977">Nepal (+977)</option>
                                    <option value="31">Netherlands (+31)</option>
                                    <option value="599">Netherlands Antilles (+599)</option>
                                    <option value="687">New Caledonia (+687)</option>
                                    <option value="64">New Zealand (+64)</option>
                                    <option value="505">Nicaragua (+505)</option>
                                    <option value="227">Niger (+227)</option>
                                    <option value="234">Nigeria (+234)</option>
                                    <option value="683">Niue (+683)</option>
                                    <option value="672">Norfolk Island (+672)</option>
                                    <option value="850">North Korea (+850)</option>
                                    <option value="1 670">Northern Mariana Islands (+1 670)</option>
                                    <option value="47">Norway (+47)</option>
                                    <option value="968">Oman (+968)</option>
                                    <option value="92">Pakistan (+92)</option>
                                    <option value="680">Palau (+680)</option>
                                    <option value="507">Panama (+507)</option>
                                    <option value="675">Papua New Guinea (+675)</option>
                                    <option value="595">Paraguay (+595)</option>
                                    <option value="51">Peru (+51)</option>
                                    <option value="63">Philippines (+63)</option>
                                    <option value="870">Pitcairn Islands (+870)</option>
                                    <option value="48">Poland (+48)</option>
                                    <option value="351">Portugal (+351)</option>
                                    <option value="1">Puerto Rico (+1)</option>
                                    <option value="974">Qatar (+974)</option>
                                    <option value="242">Republic of the Congo (+242)</option>
                                    <option value="40">Romania (+40)</option>
                                    <option value="7">Russia (+7)</option>
                                    <option value="250">Rwanda (+250)</option>
                                    <option value="590">Saint Barthelemy (+590)</option>
                                    <option value="290">Saint Helena (+290)</option>
                                    <option value="1 869">Saint Kitts and Nevis (+1 869)</option>
                                    <option value="1 758">Saint Lucia (+1 758)</option>
                                    <option value="1 599">Saint Martin (+1 599)</option>
                                    <option value="508">Saint Pierre and Miquelon (+508)</option>
                                    <option value="1 784">Saint Vincent and the Grenadines (+1 784)</option>
                                    <option value="685">Samoa (+685)</option>
                                    <option value="378">San Marino (+378)</option>
                                    <option value="239">Sao Tome and Principe (+239)</option>
                                    <option value="966">Saudi Arabia (+966)</option>
                                    <option value="221">Senegal (+221)</option>
                                    <option value="381">Serbia (+381)</option>
                                    <option value="248">Seychelles (+248)</option>
                                    <option value="232">Sierra Leone (+232)</option>
                                    <option value="65">Singapore (+65)</option>
                                    <option value="421">Slovakia (+421)</option>
                                    <option value="386">Slovenia (+386)</option>
                                    <option value="677">Solomon Islands (+677)</option>
                                    <option value="252">Somalia (+252)</option>
                                    <option value="27">South Africa (+27)</option>
                                    <option value="82">South Korea (+82)</option>
                                    <option value="34">Spain (+34)</option>
                                    <option value="94">Sri Lanka (+94)</option>
                                    <option value="249">Sudan (+249)</option>
                                    <option value="597">Suriname (+597)</option>
                                    <option value="268">Swaziland (+268)</option>
                                    <option value="46">Sweden (+46)</option>
                                    <option value="41">Switzerland (+41)</option>
                                    <option value="963">Syria (+963)</option>
                                    <option value="886">Taiwan (+886)</option>
                                    <option value="992">Tajikistan (+992)</option>
                                    <option value="255">Tanzania (+255)</option>
                                    <option value="66">Thailand (+66)</option>
                                    <option value="670">Timor-Leste (+670)</option>
                                    <option value="228">Togo (+228)</option>
                                    <option value="690">Tokelau (+690)</option>
                                    <option value="676">Tonga (+676)</option>
                                    <option value="1 868">Trinidad and Tobago (+1 868)</option>
                                    <option value="216">Tunisia (+216)</option>
                                    <option value="90">Turkey (+90)</option>
                                    <option value="993">Turkmenistan (+993)</option>
                                    <option value="1 649">Turks and Caicos Islands (+1 649)</option>
                                    <option value="688">Tuvalu (+688)</option>
                                    <option value="256">Uganda (+256)</option>
                                    <option value="380">Ukraine (+380)</option>
                                    <option value="971">United Arab Emirates (+971)</option>
                                    <option value="44">United Kingdom (+44)</option>
                                    <option value="1">United States (+1)</option>
                                    <option value="598">Uruguay (+598)</option>
                                    <option value="1 340">US Virgin Islands (+1 340)</option>
                                    <option value="998">Uzbekistan (+998)</option>
                                    <option value="678">Vanuatu (+678)</option>
                                    <option value="58">Venezuela (+58)</option>
                                    <option value="84">Vietnam (+84)</option>
                                    <option value="681">Wallis and Futuna (+681)</option>
                                    <option value="970">West Bank (+970)</option>
                                    <option value="967">Yemen (+967)</option>
                                    <option value="260">Zambia (+260)</option>
                                    <option value="263">Zimbabwe (+263)</option>
                                  </select>
                                </div>
                                <div className="inpt">
                                  <input className={`form-control form-control-solid ${error?.mobile ? "is-invalid" : ""
                                    }`} name="mobile" type="text" placeholder="."
                                    value={contactDetails.mobile}
                                    maxLength={10}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, "");
                                      ChangeContactDetails({
                                        target: {
                                          name: "mobile",
                                          value: value,
                                        },
                                      });
                                    }}
                                  />
                                  {error?.mobile && (
                                    <small className="text-danger">{error.mobile}</small>
                                  )}
                                </div>
                              </div>

                            </div>
                          </div>

                          <p>Your booking details will sent to this email address and mobile number.</p>
                        </div>

                        <h5>Traveller Information</h5>
                        <p className="note"><span>Important Note :</span> Please ensure that the name of the passengers on the travel documents is the same on their government issued identity proof.</p>

                        {/* Adult */}
                        {error["adult_empty"] && (
                          <p className="text-danger fw-bold">{error["adult_empty"]}</p>
                        )}
                        {flightAvailibilies && flightAvailibilies[0].adult > 0 &&
                          Array.from({ length: flightAvailibilies[0].adult }).map((_, index) => (
                            // flightAvailibilies[0].adult.map((item, index) => (
                            <div className="row Adult" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Adult {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select
                                      name={`adults[${index}].title`}
                                      className="form-select form-select-solid"
                                      onChange={(e) => handleTravellerChange("adults", index, "title", e.target.value)}
                                    >

                                      <option value="Select">Select</option>
                                      <option value="Mr">Mr.</option>
                                      <option value="Ms">Ms.</option>
                                      <option value="Mrs">Mrs.</option>

                                    </select>
                                    {error[`adult_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`adult_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">

                                    <input className="form-control form-control-solid" name="{`adults[${index}].firstName`}" type="text" placeholder="First Name.."
                                      //ref={(el) => (inputRefs.current[`adults_${index}_firstName`] = el)}
                                      value={travellers.adults?.[index]?.firstName || ""}
                                      // value={firstName}
                                      onChange={(e) => handleTravellerChange("adults", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`adult_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`adult_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`adults[${index}].lastName`} type="text" placeholder="Last Name.."
                                  value={travellers.adults?.[index]?.lastName || ""}
                                  onChange={(e) => handleTravellerChange("adults", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/; // allow letters and space only
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`adult_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`adult_${index}_lastName`]}
                                  </span>
                                )}
                              </div>
                              {
                                flightAvailibilies?.[0]?.conditions?.dob?.adobr === true && (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <DatePicker
                                          name={`adults[${index}].dob`}
                                          selected={
                                            travellers?.adults?.[index]?.dob
                                              ? new Date(travellers.adults[index].dob)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date
                                              ? date.toISOString().split("T")[0]
                                              : "";

                                            handleTravellerChange("adults", index, "dob", formatted);
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="Date of Birth"
                                          dateFormat="dd/MM/yyyy"
                                          showYearDropdown
                                          scrollableYearDropdown
                                          minDate={getDateYearsAgo(90)}     // max age 90
                                          maxDate={getDateYearsAgo(12, 1)}  // strictly > 12
                                        />
                                      </div>
                                    </div>
                                  </>
                                )
                              }

                              {
                                flightAvailibilies?.[0]?.trip === 2 &&
                                (flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>

                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`adults[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("adults", index, "passportNo", e.target.value)}
                                        />
                                        {error[`adult_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`adults[${index}].issuingCountry`}
                                          value={travellers?.adults?.[index]?.issuingCountry || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "adults",
                                              index,
                                              "issuingCountry",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Country</option>

                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`adult_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    {/* <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>

                                        <DatePicker
                                          name={`adults[${index}].issueDate`}
                                          selected={
                                            travellers?.adults?.[index]?.issueDate
                                              ? new Date(travellers.adults[index].issueDate)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date ? date.toISOString().split("T")[0] : "";
                                            handleTravellerChange("adults", index, "issueDate", formatted);
                                          }} className="form-control form-control-solid"
                                        />
                                        {error[`adult_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div> */}

                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`adults[${index}].nationality`}
                                          value={travellers?.adults?.[index]?.nationality || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "adults",
                                              index,
                                              "nationality",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Nationality</option>

                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`adult_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>

                                        <DatePicker
                                          name={`adults[${index}].expiryDate`}
                                          selected={
                                            travellers?.adults?.[index]?.expiryDate
                                              ? new Date(travellers.adults[index].expiryDate.split("/").reverse().join("-")
                                              )
                                              : null
                                          }
                                          onChange={(date) => {
                                            if (!date) {
                                              handleTravellerChange("adults", index, "expiryDate", "");
                                              return;
                                            }

                                            //  Store as YYYY-MM-DD (API Safe Format)
                                            //const formatted = date.toISOString().split("T")[0];
                                            const day = String(date.getDate()).padStart(2, "0");
                                            const month = String(date.getMonth() + 1).padStart(2, "0");
                                            const year = date.getFullYear();

                                            const formatted = `${day}/${month}/${year}`;

                                            handleTravellerChange(
                                              "adults",
                                              index,
                                              "expiryDate",
                                              formatted
                                            );
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="DD/MM/YYYY"
                                          dateFormat="dd/MM/yyyy"   //  Display Format
                                          minDate={new Date()}      // Expiry must be future
                                          showYearDropdown
                                          scrollableYearDropdown
                                        />

                                        {error[`adult_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                  </>
                                )
                              }
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="--Select--"
                                        options={airlineOptions}
                                        value={
                                          airlineOptions.find(
                                            option => option.value === travellers.adults[index]?.airline
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          handleTravellerChange("adults", index, "airline", selectedOption?.value || "");
                                        }}
                                      />
                                      {error[`adult_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`adult_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label>Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`adults[${index}].frequentFlyerNo`} value={travellers.adults[index]?.frequentFlyerNo || ""} type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("adults", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`adult_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`adult_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 mt-5 mb-5">
                                <div className="row">
                                  {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                                    <>
                                      <div className="form-check form-check-inline col-md-5">
                                        <input className="form-check-input" id="Active" name={`adults[${index}].saveInfo`} type="checkbox" value="1"
                                          onChange={(e) => handleTravellerChange("adults", index, "saveInfo", e.target.checked)}
                                        />
                                        {error[`adult_${index}_saveInfo`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_saveInfo`]}
                                          </span>
                                        )}
                                        <label className="form-check-label" for="Active">Create Corporate Traveller Profile.</label>
                                      </div>
                                    </>
                                  )}

                                  {travellers?.adults[index]?.saveInfo && (
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label className="required">Email ID/User Name</label>
                                        <input
                                          className="form-control form-control-solid"
                                          name={`adults[${index}].userName`}
                                          type="text"
                                          placeholder="."
                                          value={travellers?.adults[index]?.userName || ""}
                                          onChange={(e) =>
                                            handleTravellerChange("adults", index, "userName", e.target.value)
                                          }
                                        />

                                        {error[`adult_${index}_userName`] && (
                                          <span className="text-danger small">
                                            {error[`adult_${index}_userName`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )
                          )}
                        {/* Child */}
                        {flightAvailibilies && flightAvailibilies[0].child > 0 &&
                          Array.from({ length: flightAvailibilies[0].child }).map((_, index) => (
                            <div className="row Child" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Child {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select className="form-select form-select-solid"
                                      name={`children[${index}].title`}
                                      onChange={(e) => handleTravellerChange("children", index, "title", e.target.value)}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="MR">Mast</option>
                                      <option value="MS">Miss</option>
                                    </select>
                                    {error[`child_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`child_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">
                                    <input className="form-control form-control-solid" name={`children[${index}].firstName`} type="text" placeholder="First Name.."
                                      onChange={(e) => handleTravellerChange("children", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`child_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`child_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`children[${index}].lastName`} type="text" placeholder="Last Name.."
                                  onChange={(e) => handleTravellerChange("children", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/;
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`child_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`child_${index}_lastName`]}
                                  </span>
                                )}
                              </div>
                              {
                                flightAvailibilies?.[0]?.conditions?.dob?.cdobr === true && (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <DatePicker
                                          name={`children[${index}].dob`}
                                          selected={
                                            travellers?.children?.[index]?.dob
                                              ? new Date(travellers.children[index].dob)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date
                                              ? date.toISOString().split("T")[0]
                                              : "";

                                            handleTravellerChange("children", index, "dob", formatted);
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="Date of Birth"
                                          dateFormat="dd/MM/yyyy"
                                          showYearDropdown
                                          scrollableYearDropdown
                                          minDate={getDateYearsAgo(12)}   // Not older than 12
                                          maxDate={getDateYearsAgo(2)}    // Not younger than 2
                                        />
                                      </div>
                                    </div>
                                  </>
                                )
                              }

                              {
                                flightAvailibilies?.[0]?.trip === 2 &&
                                (flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>

                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "passportNo", e.target.value)}
                                        />
                                        {error[`child_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`children[${index}].issuingCountry`}
                                          value={travellers?.children?.[index]?.issuingCountry || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "children",
                                              index,
                                              "issuingCountry",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Country</option>

                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`child_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`children[${index}].nationality`}
                                          value={travellers?.children?.[index]?.nationality || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "children",
                                              index,
                                              "nationality",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Nationality</option>
                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`child_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    {/* <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>
                                        <input className="form-control form-control-solid" name={`children[${index}].issueDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("children", index, "issueDate", e.target.value)}
                                        />
                                        {error[`child_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div> */}
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>

                                        <DatePicker
                                          name={`children[${index}].expiryDate`}
                                          selected={
                                            travellers?.children?.[index]?.expiryDate
                                              ? new Date(
                                                travellers.children[index].expiryDate
                                                  .split("/")
                                                  .reverse()
                                                  .join("-")
                                              )
                                              : null
                                          }
                                          onChange={(date) => {
                                            if (!date) {
                                              handleTravellerChange("children", index, "expiryDate", "");
                                              return;
                                            }

                                            const day = String(date.getDate()).padStart(2, "0");
                                            const month = String(date.getMonth() + 1).padStart(2, "0");
                                            const year = date.getFullYear();

                                            const formatted = `${day}/${month}/${year}`;

                                            handleTravellerChange(
                                              "children",
                                              index,
                                              "expiryDate",
                                              formatted
                                            );
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="DD/MM/YYYY"
                                          dateFormat="dd/MM/yyyy"
                                          minDate={new Date()}   // Expiry must be future
                                          showYearDropdown
                                          scrollableYearDropdown
                                        />
                                        {error[`child_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )
                              }

                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="--Select--"
                                        options={airlineOptions}
                                        value={
                                          airlineOptions.find(
                                            option => option.value === travellers.adults[index]?.airline
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          handleTravellerChange("children", index, "airline", selectedOption?.value || "");
                                        }}
                                      />
                                      {error[`child_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label >Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`children[${index}].frequentFlyerNo`} defaultValue="" type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("children", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`child_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 mt-5 mb-5">
                                <div className="row">
                                  {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                                    <>
                                      <div className="form-check form-check-inline col-md-6">
                                        <input className="form-check-input" id="Active" name={`children[${index}].saveInfo`} type="checkbox" value="1"
                                          onChange={(e) => handleTravellerChange("children", index, "saveInfo", e.target.checked)}
                                        />
                                        {error[`child_${index}_saveInfo`] && (
                                          <span className="text-danger small">
                                            {error[`child_${index}_saveInfo`]}
                                          </span>
                                        )}
                                        <label className="form-check-label" for="Active">Create Corporate Traveller Profile</label>
                                      </div>
                                    </>
                                  )}
                                </div>
                                {travellers?.children[index]?.saveInfo && (
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="required">Email ID/User Name</label>
                                      <input
                                        className="form-control form-control-solid"
                                        name={`children[${index}].userName`}
                                        type="text"
                                        placeholder="."
                                        value={travellers?.children[index]?.userName || ""}
                                        onChange={(e) =>
                                          handleTravellerChange("children", index, "userName", e.target.value)
                                        }
                                      />

                                      {error[`child_${index}_userName`] && (
                                        <span className="text-danger small">
                                          {error[`child_${index}_userName`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        {/* Infant */}
                        {flightAvailibilies && flightAvailibilies[0].infant > 0 &&
                          Array.from({ length: flightAvailibilies[0].infant }).map((_, index) => (
                            <div className="row Infant" key={index}>
                              <div className="col-md-2">
                                <h4 className="Adult">Infant {index + 1}</h4>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex">
                                  <div className="selct">
                                    <select className="form-select form-select-solid"
                                      name={`infants[${index}].title`}
                                      onChange={(e) => handleTravellerChange("infants", index, "title", e.target.value)}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="Mast">Mast</option>
                                      <option value="Miss">Miss</option>
                                    </select>
                                    {error[`infant_${index}_title`] && (
                                      <span className="text-danger small">
                                        {error[`infant_${index}_title`]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inpt">
                                    <input className="form-control form-control-solid" name={`infants[${index}].firstName`} type="text" placeholder="First Name.."
                                      onChange={(e) => handleTravellerChange("infants", index, "firstName", e.target.value)}
                                      onKeyPress={(e) => {
                                        const char = e.key;
                                        const regex = /[A-Za-z ]/;
                                        if (!regex.test(char)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    {error[`infant_${index}_firstName`] && (
                                      <span className="text-danger small">
                                        {error[`infant_${index}_firstName`]}
                                      </span>
                                    )}
                                  </div>
                                </div>

                              </div>
                              <div className="col-md-3">
                                <input className="form-control form-control-solid" name={`infants[${index}].lastName`} type="text" placeholder="Last Name.."
                                  onChange={(e) => handleTravellerChange("infants", index, "lastName", e.target.value)}
                                  onKeyPress={(e) => {
                                    const char = e.key;
                                    const regex = /[A-Za-z ]/;
                                    if (!regex.test(char)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {error[`infant_${index}_lastName`] && (
                                  <span className="text-danger small">
                                    {error[`infant_${index}_lastName`]}
                                  </span>
                                )}
                              </div>
                              {
                                flightAvailibilies?.[0]?.conditions?.dob?.idobr === true && (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <DatePicker
                                          name={`infants[${index}].dob`}
                                          selected={
                                            travellers?.infants?.[index]?.dob
                                              ? new Date(travellers.infants[index].dob)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date
                                              ? date.toISOString().split("T")[0]
                                              : "";

                                            handleTravellerChange("infants", index, "dob", formatted);
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="Date of Birth"
                                          dateFormat="dd/MM/yyyy"
                                          showYearDropdown
                                          scrollableYearDropdown
                                          minDate={getDateYearsAgo(2)}   // Not older than 2 years
                                          maxDate={today}                // Cannot be future
                                        />
                                      </div>
                                    </div>
                                  </>
                                )
                              }

                              {
                                flightAvailibilies?.[0]?.trip === 2 &&
                                (flightAvailibilies?.[0]?.sCode !== "Indigo" &&
                                  flightAvailibilies?.[0]?.sCode !== "SpiceJet") && (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <DatePicker
                                          name={`infants[${index}].dob`}
                                          selected={
                                            travellers?.infants?.[index]?.dob
                                              ? new Date(travellers.infants[index].dob)
                                              : null
                                          }
                                          onChange={(date) => {
                                            const formatted = date
                                              ? date.toISOString().split("T")[0]
                                              : "";

                                            handleTravellerChange("infants", index, "dob", formatted);
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="Date of Birth"
                                          dateFormat="dd/MM/yyyy"
                                          showYearDropdown
                                          scrollableYearDropdown
                                          minDate={getDateYearsAgo(2)}   // Not older than 2
                                          maxDate={today}               // Cannot be future
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Passport No</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].passportNo`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "passportNo", e.target.value)}
                                        />
                                        {error[`infant_${index}_passportNo`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_passportNo`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issuing Country</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`infants[${index}].issuingCountry`}
                                          value={travellers?.infants?.[index]?.issuingCountry || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "infants",
                                              index,
                                              "issuingCountry",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Country</option>
                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`infant_${index}_issuingCountry`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_issuingCountry`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Nationality</label>
                                        <select
                                          className="form-select form-select-solid"
                                          name={`infants[${index}].nationality`}
                                          value={travellers?.infants?.[index]?.nationality || ""}
                                          onChange={(e) =>
                                            handleTravellerChange(
                                              "infants",
                                              index,
                                              "nationality",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Nationality</option>
                                          {countries?.map((country) => (
                                            <option key={country.id} value={country.countryCode}>
                                              {country.countryName}
                                            </option>
                                          ))}
                                        </select>

                                        {error[`infant_${index}_nationality`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_nationality`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    {/* <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Issue Date</label>
                                        <input className="form-control form-control-solid" name={`infants[${index}].issueDate`} defaultValue="" type="text" placeholder="."
                                          onChange={(e) => handleTravellerChange("infants", index, "issueDate", e.target.value)}
                                        />
                                        {error[`infant_${index}_issueDate`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_issueDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div> */}
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label className="required">Expiry Date</label>
                                        <DatePicker
                                          name={`infants[${index}].expiryDate`}
                                          selected={
                                            travellers?.infants?.[index]?.expiryDate
                                              ? new Date(
                                                travellers.infants[index].expiryDate.split("/").reverse().join("-")
                                              )
                                              : null
                                          }
                                          onChange={(date) => {
                                            if (!date) {
                                              handleTravellerChange("infants", index, "expiryDate", "");
                                              return;
                                            }

                                            const day = String(date.getDate()).padStart(2, "0");
                                            const month = String(date.getMonth() + 1).padStart(2, "0");
                                            const year = date.getFullYear();

                                            const formatted = `${day}/${month}/${year}`;

                                            handleTravellerChange("infants", index, "expiryDate", formatted);
                                          }}
                                          className="form-control form-control-solid"
                                          placeholderText="DD/MM/YYYY"
                                          dateFormat="dd/MM/yyyy"
                                          minDate={new Date()}   // passport expiry must be future
                                          showYearDropdown
                                          scrollableYearDropdown
                                        />
                                        {error[`infant_${index}_expiryDate`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_expiryDate`]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )
                              }
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="">Airline</label>
                                      <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="--Select--"
                                        options={airlineOptions}
                                        value={
                                          airlineOptions.find(
                                            option => option.value === travellers.adults[index]?.airline
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          handleTravellerChange("infants", index, "airline", selectedOption?.value || "");
                                        }}
                                      />
                                      {error[`infant_${index}_airline`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_airline`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label >Frequent Flyer No</label>
                                      <input className="form-control form-control-solid" name={`infants[${index}].frequentFlyerNo`} defaultValue="" type="text" placeholder="."
                                        onChange={(e) => handleTravellerChange("infants", index, "frequentFlyerNo", e.target.value)}
                                      />
                                      {error[`infant_${index}_frequentFlyerNo`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_frequentFlyerNo`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12 mt-5 mb-5">
                                <div className="row">
                                  {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                                    <>
                                      <div className="form-check form-check-inline col-md-6">
                                        <input className="form-check-input" id="Active" name={`infants[${index}].saveInfo`} type="checkbox" value="1"
                                          onChange={(e) => handleTravellerChange("infants", index, "saveInfo", e.target.checked)}
                                        />
                                        {error[`infant_${index}_saveInfo`] && (
                                          <span className="text-danger small">
                                            {error[`infant_${index}_saveInfo`]}
                                          </span>
                                        )}
                                        <label className="form-check-label" for="Active">Create Corporate Traveller Profile.</label>
                                      </div>
                                    </>
                                  )}
                                </div>
                                {travellers?.infants[index]?.saveInfo && (
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="required">Email ID/User Name</label>
                                      <input
                                        className="form-control form-control-solid"
                                        name={`infants[${index}].userName`}
                                        type="text"
                                        placeholder="."
                                        value={travellers?.infants[index]?.userName || ""}
                                        onChange={(e) =>
                                          handleTravellerChange("infants", index, "userName", e.target.value)
                                        }
                                      />

                                      {error[`infant_${index}_userName`] && (
                                        <span className="text-danger small">
                                          {error[`infant_${index}_userName`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                          )}
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="">User Field 1</label>
                              <input
                                className={`form-control form-control-solid ${error?.ref1 ? "is-invalid" : ""
                                  }`}
                                name="ref1"
                                type="text"
                                value={customField.ref1}
                                onChange={handleCustomFieldChange}
                                maxLength={50}
                              />
                              {error?.ref1 && (
                                <small className="text-danger">{error.ref1}</small>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="">User Field 2</label>
                              <input
                                className={`form-control form-control-solid ${error?.ref2 ? "is-invalid" : ""
                                  }`}
                                name="ref2"
                                type="text"
                                value={customField.ref2}
                                onChange={handleCustomFieldChange}
                              />
                              {error?.ref2 && (
                                <small className="text-danger">{error.ref2}</small>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="">User Field 3</label>
                              <input
                                className={`form-control form-control-solid ${error?.ref3 ? "is-invalid" : ""
                                  }`}
                                name="ref3"
                                type="text"
                                value={customField.ref3}
                                onChange={handleCustomFieldChange}
                              />
                              {error?.ref3 && (
                                <small className="text-danger">{error.ref3}</small>
                              )}
                            </div>
                          </div>
                        </div>

                        {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                          <>
                            <h5>Billing Details</h5>
                            <div className="row">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label className="required">Billing Details</label>
                                  <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="--Select--"
                                    isLoading={loadingBillingEntities}
                                    options={billingEntitiesOptions}
                                    value={
                                      billingEntitiesOptions.find(
                                        option => option.value === organizationsDetails.billTo
                                      ) || null
                                    }
                                    // value={
                                    //   billingEntitiesOptions.find(
                                    //     option => String(option.value) === String(organizationsDetails.billTo)
                                    //   ) || null
                                    // }
                                    onChange={(selectedOption) => {
                                      ChangeBillingDetails(selectedOption?.value || "");
                                    }}
                                  />
                                  {error.billTo && (
                                    <span className="text-danger small">
                                      {error.billTo}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}


                        {/* {flightAvailibilies && flightAvailibilies[0].isGSTMandatory == true && ( */}
                        {/* <> */}
                        <h5>GST Details</h5>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="required">GST Number</label>
                              {/* <div className="form-control">{gstInfo.gstNumber}</div> */}
                              <input
                                className={`form-control form-control-solid ${error?.gstIn ? "is-invalid" : ""
                                  }`}
                                name="gstNumber"
                                type="text"
                                value={contactDetails.gstNumber}
                                onChange={ChangeContactDetails}
                                maxLength={15}
                              />
                              {error?.gstIn && (
                                <small className="text-danger">{error.gstIn}</small>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="required">Name</label>
                              {/* <div className="form-control">{gstInfo.gstName} </div> */}
                              <input
                                className={`form-control form-control-solid ${error?.nameOnGst ? "is-invalid" : ""
                                  }`}
                                name="gstName"
                                type="text"
                                value={contactDetails.gstName}
                                onChange={ChangeContactDetails}
                              />
                              {error?.nameOnGst && (
                                <small className="text-danger">{error.nameOnGst}</small>
                              )}
                            </div>
                          </div>



                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="required">Email</label>
                              <input
                                className={`form-control form-control-solid ${error?.emailOngst ? "is-invalid" : ""
                                  }`}
                                name="emailOngst"
                                type="text"
                                value={contactDetails.emailOngst}
                                onChange={ChangeContactDetails}
                              />
                              {error?.emailOngst && (
                                <small className="text-danger">{error.emailOngst}</small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="required">Phone</label>
                              <input
                                className={`form-control form-control-solid ${error?.phoneOnGst ? "is-invalid" : ""
                                  }`}
                                name="phoneOnGst"
                                type="text"
                                value={contactDetails.phoneOnGst}
                                maxLength={10}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "");
                                  ChangeContactDetails({
                                    target: {
                                      name: "phoneOnGst",
                                      value: value,
                                    },
                                  });
                                }}
                              />
                              {error?.phoneOnGst && (
                                <small className="text-danger">{error.phoneOnGst}</small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="required">Address</label>
                              <input
                                className={`form-control form-control-solid ${error?.addressOnGst ? "is-invalid" : ""
                                  }`}
                                name="addressOnGst"
                                type="text"
                                value={contactDetails.addressOnGst}
                                onChange={ChangeContactDetails}
                              />
                              {error?.addressOnGst && (
                                <small className="text-danger">{error.addressOnGst}</small>
                              )}
                            </div>
                          </div>

                        </div>
                        {/* </>
                        )} */}
                      </div>
                      {/* <div className="col-md-12">
                        <span>Organization Type : {contactDetails.organizationType}</span>
                      </div> */}

                    </div>
                    {/* special Service start */}
                    <div className="row mb-10">
                      <div className="col-md-12">
                        <div className="depatre">
                          <h4 className="sub_heading">Service Requests <sub>(Optional)</sub></h4>
                          <ul class="nav nav-tabs" role="tablist">
                            {showSeatOption && (
                              <li class="nav-item">
                                <a
                                  className="btn btn-primary nav-link"
                                  data-bs-toggle="tab"
                                  href="#SeatMap"
                                >
                                  Seat Map <i className="fa fa-plus"></i>
                                </a>

                              </li>
                            )}
                            {showExtraBaggage && (
                              <li class="nav-item">
                                <a class="btn btn-primary nav-link" data-bs-toggle="tab" href="#AddBaggage">Add Baggage <i className="fa fa-plus"></i> </a>
                              </li>
                            )}
                            {showMealOption && (
                              <li class="nav-item">
                                <a class="btn btn-primary nav-link" data-bs-toggle="tab" href="#AddMeal">Add Meal <i className="fa fa-plus"></i></a>
                              </li>
                            )}
                          </ul>
                          {isSeatRequired && error?.seatRequired && (
                            <div className="alert alert-danger py-2 fw-bold">
                              {error.seatRequired}
                            </div>
                          )}
                          {isBaggageRequired && error?.baggageRequired && (
                            <div className="alert alert-danger py-2 fw-bold">{error.baggageRequired}</div>
                          )}

                          {isMealRequired && error?.mealRequired && (
                            <div className="alert alert-danger py-2 fw-bold">{error.mealRequired}</div>
                          )}

                          <div class="tab-content">
                            <div id="SeatMap" class="tab-pane">
                              <div class="col-md-12 mt-10 mb-3"><div class="d-flex">
                                <div class="d-flex m-2"><span class="Available">
                                </span>Available</div>
                                <div class="d-flex m-2">
                                  <span class="Occupied"></span>Occupied</div>
                                <div class="d-flex m-2"><span class="Selected"></span>Selected</div>
                                <div class="d-flex m-2"><span class="isExitRow"></span>Exit Row</div></div>
                              </div>

                              <FlightSeatSelection
                                flightAvailibilies={flightAvailibilies}
                                seatSelections={seatSelections}
                                setSeatSelections={setSeatSelections}
                                keyParam={key}
                                referenceNo={referenceNo}
                              />
                            </div>


                            <div id="AddBaggage" className="tab-pane">
                              {ssrResult.map((res, index) => {


                                if (!res?.sectorWiseBaggages?.length) return null;

                                return res.sectorWiseBaggages.map((sectorWiseBaggage, mdlIndex) => {

                                  const baggageList = sectorWiseBaggage?.baggages || [];
                                  if (!baggageList.length) return null;


                                  return (
                                    <div className="tab-pan mb-3" key={index}>

                                      <p className="del_uid">
                                        {sectorWiseBaggage.origin} → {sectorWiseBaggage.destination}
                                      </p>

                                      {["ADULT", "CHILD"].map((paxType) => {

                                        const count = availability?.[paxType.toLowerCase()] || 0;
                                        if (!count) return null;

                                        return Array.from({ length: count }).map((_, paxIndex) => {

                                          return (
                                            <div className="row mb-3" key={`${res.origin}_${res.destination}_${paxType}_${paxIndex}`}>

                                              <div className="col-md-1">
                                                <h4 className="Adult mt-5 m-0">
                                                  {paxType} {paxIndex + 1}
                                                </h4>
                                              </div>

                                              <div className="col-md-11 d-flexs">

                                                {baggageList.map((item) => {
                                                  const sectorKey = `${item.origin}_${item.destination}_${res.trackID}`;
                                                  const uniqueKey = `${res.origin}_${res.destination}_${res.trackID}_${paxType}_${paxIndex}_${item?.code}`;
                                                  const isSelected = !!selectedBaggage[uniqueKey];

                                                  return (
                                                    <div className="box_shadow_meal" key={uniqueKey}>
                                                      <div className="d-flex">

                                                        <div className="M_img_A">
                                                          <img src="/assets/images/baggages.png" alt="baggage" />
                                                        </div>

                                                        <div className="M_img_B">
                                                          <h6>{item.description}</h6>
                                                        </div>

                                                        <div className="M_img_C">
                                                          <p className="M_price">₹{item.price}</p>

                                                          <button
                                                            type="button"
                                                            className="btn-btn-sm"
                                                            style={{
                                                              color: isSelected ? "#dacd65" : "#ff0000"
                                                            }}
                                                            onClick={() =>
                                                              ChangeAddBaggage(
                                                                item,
                                                                paxIndex,
                                                                paxType,
                                                                sectorKey,
                                                                res.trackID || index
                                                              )
                                                            }
                                                          >
                                                            {isSelected ? "Remove" : "Add"}
                                                          </button>

                                                        </div>

                                                      </div>
                                                    </div>
                                                  );
                                                })}

                                              </div>
                                            </div>
                                          );
                                        });
                                      })}

                                    </div>
                                  );
                                });
                              })}
                            </div>

                            <div id="AddMeal" className="tab-pane fade">
                              {ssrResult?.map((res, index) => {

                                if (!res?.sectorWiseMeals?.length) return null;

                                return res.sectorWiseMeals.map((sectorWiseMeal, mdlIndex) => {

                                  const mealList = sectorWiseMeal?.meals || [];
                                  if (!mealList.length) return null;

                                  const sectorKey = `${sectorWiseMeal.origin}_${sectorWiseMeal.destination}_${res.trackID}`;

                                  return (
                                    <div className="tab-pan mb-3" key={index}>

                                      <p className="del_uid">
                                        {sectorWiseMeal.origin} → {sectorWiseMeal.destination}
                                      </p>

                                      {["ADULT", "CHILD"].map((paxType) => {

                                        const count = availability?.[paxType.toLowerCase()] || 0;
                                        if (!count) return null;

                                        return Array.from({ length: count }).map((_, paxIndex) => {

                                          return (
                                            <div className="row mb-2" key={`${paxType}-${paxIndex}`}>

                                              <div className="col-md-1">
                                                <h4 className="Adult mt-5 m-0">
                                                  {paxType} {paxIndex + 1}
                                                </h4>
                                              </div>

                                              <div className="col-md-11 d-flexs">

                                                {mealList.map((item) => {

                                                  const uniqueKey = `${sectorKey}_${paxType}_${paxIndex}_${item?.code}`;
                                                  const isSelected = !!selectedMeal[uniqueKey];

                                                  return (
                                                    <div className="box_shadow_meal" key={uniqueKey}>
                                                      <div className="d-flex">

                                                        <div className="M_img_A">
                                                          <img src="/assets/images/meal.png" alt="meal" />
                                                        </div>

                                                        <div className="M_img_B">
                                                          <h6>{item.description}</h6>
                                                        </div>

                                                        <div className="M_img_C">
                                                          <p className="M_price">₹{item.price}</p>

                                                          <button
                                                            type="button"
                                                            className="btn-btn-sm"
                                                            style={{
                                                              color: isSelected ? "#dacd65" : "#ff0000"
                                                            }}
                                                            onClick={() =>
                                                              ChangeAddMeal(
                                                                item,
                                                                paxIndex,
                                                                paxType,
                                                                sectorKey,
                                                                res.trackID || index
                                                              )
                                                            }
                                                          >
                                                            {isSelected ? "Remove" : "Add"}
                                                          </button>

                                                        </div>

                                                      </div>
                                                    </div>
                                                  );
                                                })}

                                              </div>
                                            </div>
                                          );
                                        });
                                      })}

                                    </div>
                                  );
                                });

                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* special Service End */}

                    <div className="button-list">
                      <a className="btn-btn-border" href="/flight">
                        Back To Search
                      </a>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          nextStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                {/* Step 2 */}
                {step === 2 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Fligth Details</h4>
                      <div className="row">
                        {flightAvailibilies && flightAvailibilies.length > 0 && (
                          flightAvailibilies[0].TripType === "MultiCity" ? (
                            <>
                              <div className="row">
                                <div className="col-lg-12">
                                  <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                  <div className="row">
                                    <div className="col-md-2">
                                      <div className="flight_img">
                                        <img
                                          className="img_icon"
                                          src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                          alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                          onError={(e) => {
                                            e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                          }}
                                        />                                      </div>
                                      <div className="name_code">
                                        <span>IX - 1194</span>
                                        <span>Air India Express</span>
                                      </div>
                                    </div>
                                    <div className="col-md-10">
                                      <div className="row">
                                        <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>Delhi</p>
                                            <h4>DEL <span>|</span> 23:30</h4>
                                            <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                            <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="deruation">
                                            <p>02:15  |  0 STOP </p>
                                            <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                            <p className="">
                                              <span>Economy </span>
                                              <span>Partial Refundable</span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>Mumbai</p>
                                            <h4>BOM <span>|</span> 01:45</h4>
                                            <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                            <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="baggage">
                                            <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                            <p>Check-in :<strong>15 Kg / person</strong></p>
                                            <p>Cabin :<strong>07 Kg/ person</strong></p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {oF && oF.length > 0 && (
                                <>
                                  <div className="row">
                                    {oF.map((segment, index) => (
                                      <div className="col-lg-12" key={index}>
                                        <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                        <div className="row">
                                          <div className="col-md-2">
                                            <div className="flight_img">
                                              <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                              {/* <img className="img_icon" src="/assets/images/flight/flight_v.png" alt="flight" /> */}
                                              {/* <img className="img_icon" src={`/assets/images/flight/${segment.marketingCarrier}.png`} alt="flight" /> */}
                                            </div>
                                            <div className="name_code">
                                              <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                              <span>{segment.airLineName}</span>
                                            </div>
                                          </div>
                                          <div className="col-md-10">
                                            <div className="row">
                                              <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.departCityName}</p>
                                                  <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="deruation">
                                                  {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                                  ) : (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                                  )}

                                                  <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                  <p className="">
                                                    {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                      <span>{segment.travelClass}</span>
                                                    )}

                                                    {flightAvailibilies[0].isRefundable ? (
                                                      <span>Partially Refundable</span>
                                                    ) : (
                                                      <span>Non-Refundable</span>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.arrivalCityName}</p>
                                                  <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                {/* <div className="baggage">
                                                  <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                  <p>Check-in :<strong>15 Kg / person</strong></p>
                                                  <p>Cabin :<strong>07 Kg/ person</strong></p>
                                                </div> */}
                                                {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                  <div className="baggage">
                                                    <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                    <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                                    <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}


                                  </div>
                                </>
                              )}
                              {rF && rF.length > 0 && (
                                <>
                                  <div className="row">
                                    {rF.map((segment, index) => (
                                      <div className="col-lg-12" key={index}>

                                        <p className="departure"><i className="fa fa-plane"></i> Return</p>
                                        <div className="row">
                                          <div className="col-md-2">
                                            <div className="flight_img">
                                              <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                            </div>
                                            <div className="name_code">
                                              <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                              <span>{segment.airLineName}</span>
                                            </div>
                                          </div>
                                          <div className="col-md-10">
                                            <div className="row">
                                              <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.departCityName}</p>
                                                  <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="deruation">
                                                  {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                                  ) : (
                                                    <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                                  )}

                                                  <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                                  <p className="">
                                                    {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                      <span>{segment.travelClass}</span>
                                                    )}

                                                    {flightAvailibilies[0].isRefundable ? (
                                                      <span>Partially Refundable</span>
                                                    ) : (
                                                      <span>Non-Refundable</span>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="timer">
                                                  <p>{segment.arrivalCityName}</p>
                                                  <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                                  <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                                    weekday: "short",
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    hour12: false
                                                  })}</p>
                                                  <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                                  <div className="baggage">
                                                    <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                                    <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                                    <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}
                            </>
                          )
                        )}



                      </div>
                      {/* Repeat */}
                    </div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Passenger Details</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>Type</th>
                                  <th>Name</th>
                                  <th>Date of Birth</th>
                                  <th>Nationality</th>
                                  <th>Passport No.</th>
                                  <th>Issuing Country</th>
                                  <th>Expiry Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* Adults */}
                                {travellers.adults.map((t, i) => (
                                  <tr key={`adult-${i}`}>
                                    <td>{i + 1}</td>
                                    <td>Adult</td>
                                    <td>{t.title} {t.firstName} {t.lastName}</td>
                                    <td>{t.dob}</td>
                                    <td>{t.nationality}</td>
                                    <td>{t.passportNo}</td>
                                    <td>{t.issuingCountry}</td>
                                    <td>{t.expiryDate}</td>
                                  </tr>
                                ))}

                                {/* Children */}
                                {travellers.children.map((t, i) => (
                                  <tr key={`child-${i}`}>
                                    <td>{i + 1}</td>
                                    <td>Child</td>
                                    <td>{t.title} {t.firstName} {t.lastName}</td>
                                    <td>{t.dob}</td>
                                    <td>{t.nationality}</td>
                                    <td>{t.passportNo}</td>
                                    <td>{t.issuingCountry}</td>
                                    <td>{t.expiryDate}</td>
                                  </tr>
                                ))}

                                {/* Infants */}
                                {travellers.infants.map((t, i) => (
                                  <tr key={`infant-${i}`}>
                                    <td>{i + 1}</td>
                                    <td>Infant</td>
                                    <td>{t.title} {t.firstName} {t.lastName}</td>
                                    <td>{t.dob}</td>
                                    <td>{t.nationality}</td>
                                    <td>{t.passportNo}</td>
                                    <td>{t.issuingCountry}</td>
                                    <td>{t.expiryDate}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Contact Details</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Email Address</th>
                                  <th>Contact Number</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{contactDetails.emailId}</td>
                                  <td>{contactDetails.countryCode} {contactDetails.mobile}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    {contactDetails?.gstNumber?.trim() && (
                      <>
                        <div className="col-md-12 col-lg-12">
                          <h4 className="sub_heading">GST Details</h4>
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Number</th>
                                      <th>Name</th>
                                      <th>Email</th>
                                      <th>Phone</th>
                                      <th>Address</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{contactDetails.gstNumber}</td>
                                      <td>{contactDetails.gstName}</td>
                                      <td>{contactDetails.emailOngst}</td>
                                      <td>{contactDetails.phoneOnGst}</td>
                                      <td>{contactDetails.addressOnGst}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}


                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">SSR</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center">Seat</th>
                                  <th className="text-center">Baggage</th>
                                  <th className="text-center">Meal</th>

                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  {/* Seat */}
                                  <td>
                                    <div className="d-flex justify-content-between">
                                      <div className="Name_p">
                                        Seats : {seatSummary.seatCount}
                                      </div>
                                      <div className="Name_pr">
                                        ₹ {seatSummary.seatTotal.toFixed(2)}
                                      </div>
                                    </div>
                                  </td>


                                  <td>
                                    <div className="d-flex justify-content-between">
                                      <div className="Name_p">
                                        Baggages : {baggageCount}
                                      </div>
                                      <div className="Name_pr">
                                        <i className="fa fa-inr"></i>{" "}
                                        {baggageTotal.toFixed(2)}
                                      </div>
                                    </div>
                                  </td>


                                  {/* Meal */}

                                  <td>
                                    <div className="d-flex justify-content-between">
                                      <div className="Name_p">
                                        Meals : {mealCount}
                                      </div>
                                      <div className="Name_pr">
                                        <i className="fa fa-inr"></i>{" "}
                                        {mealTotal.toFixed(2)}
                                      </div>
                                    </div>
                                  </td>


                                </tr>
                              </tbody>
                            </table>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="button-list">
                      <button className="btn-btn-border"
                        onClick={() => {
                          prevStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}>
                        Back
                      </button>
                      {ApprovalRequestButton}
                    </div>
                  </div>
                )}

                {/* Step 3 */}
                {step === 3 && (
                  <div>
                    <div className="col-md-12 col-lg-12">
                      <h4 className="sub_heading">Payment</h4>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="paymnt">
                            <div className="paymnt_lft">
                              <ul className="nav nav-tabs paynt" role="tablist">
                                {flightAvailibilies?.[0]?.travelPurpose !== "2" && (
                                  <li className="nav-item">
                                    <a className={`nav-link ${flightAvailibilies?.[0]?.travelPurpose !== "2" ? "active" : ""}`} data-bs-toggle="tab" href="#AgencyCredit" > Company Billing </a>
                                  </li>
                                )}
                                <li className="nav-item">
                                  <a className={`nav-link ${flightAvailibilies?.[0]?.travelPurpose === "2" ? "active" : ""}`} data-bs-toggle="tab" href="#CreditCard"> Credit Card </a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Debit Card</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Net Banking</a>
                                </li>
                                <li className="nav-item">
                                  <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">UPI</a>
                                </li>
                              </ul>
                            </div>
                            <div className="paymnt_Rgt">
                              <div className="tab-content">
                                {flightAvailibilies?.[0]?.travelPurpose !== "2" && (
                                  <div id="AgencyCredit" className={`container tab-pane ${flightAvailibilies?.[0]?.travelPurpose !== "2" ? "active" : ""}`}>
                                    <div className="balnce">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="paymentMethod"
                                        id="agencyCreditRadio"
                                        value="AgencyCreditLimit"
                                        checked={paymentMethod === "AgencyCreditLimit"}
                                        onChange={(e) => {
                                          setPaymentMethod(e.target.value)
                                          setPaymentError("");
                                        }}
                                      />
                                      <i className="fa fa-inr"></i>{(parseFloat(agencyDetails?.corporateDetails?.creditLimit ?? 0) + parseFloat(agencyDetails?.corporateDetails?.dueAmount ?? 0)).toFixed(2)}</div>
                                  </div>
                                )}
                                <div id="CreditCard" className={`container tab-pane ${flightAvailibilies?.[0]?.travelPurpose === "2" ? "active" : ""}`}>
                                  <div className="balnce">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="HdfcBank"
                                      id="HdfcBankRadio"
                                      value="HdfcBank"
                                      checked={paymentMethod === "HdfcBank"}
                                      onChange={(e) => {
                                        setPaymentMethod(e.target.value)
                                        setPaymentError("");
                                      }
                                      }
                                    />
                                    <img src="/assets/images/hdfc-logo.png" alt="payment" /> </div>
                                </div>
                                <div id="DebitCard" className="container tab-pane fade">
                                  <div className="balnce">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="paymentMethod"
                                      id="debitCardRadio"
                                      value="DebitCard"
                                      checked={paymentMethod === "DebitCard"}
                                      onChange={(e) => {
                                        setPaymentMethod(e.target.value)
                                        setPaymentError("");
                                      }}
                                    />
                                    <i className="fa fa-inr"></i>36565</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {paymentError && (
                            <div className="alert alert-danger fw-bold mt-3 py-2">
                              {paymentError}
                            </div>
                          )}
                          {/* {error && <p className="text-danger mt-3">{error}</p>}
                          {success && <p className="text-success mt-3">{success}</p>} */}
                        </div>

                        <div className="col-md-12 mt-5 mb-5">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              id="termsCheckbox"
                              name="Status"
                              type="checkbox"
                              checked={acceptedTerms}
                              onChange={(e) => {
                                setAcceptedTerms(e.target.checked);
                                if (e.target.checked) setTermsError("");
                              }}
                            />
                            {/* <input className="form-check-input" id="Active" name="Status" type="checkbox" value="1" /> */}
                            <label className="form-check-label Active" for="Active"> By clicking this button, I understand &amp; accept with the	Rules &amp; Restrictions of this fare,the Privacy Policy
                              <span data-bs-toggle="modal" data-bs-target="#term-cond" className="weak">Terms &amp; Conditions</span></label>
                          </div>
                          {termsError && (
                            <div className="alert alert-danger fw-bold mt-3 py-2">
                              {termsError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {success && (
                      <div className="col-md-12 mt-3 mb-4">
                        <div className="alert alert-success text-center fw-bold py-2 rounded">
                          {success}
                        </div>
                      </div>
                    )}

                    <div className="button-list">
                      <button
                        className="btn-btn-border"
                        onClick={() => {
                          prevStep();
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Back
                      </button>
                      {paymentButton}
                    </div>
                  </div>
                )}

              </div>
            </div>
            <div className='col-md-3 po_sticky'>
              <div className='box_shadow sticky'>
                <h6>Fare Summary</h6>
                <div className="accordion" id="kt_accordion_1">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_1">
                      <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        <div className='flex'>
                          <span> Base Fare</span>
                          <span><i className='fa fa-inr'></i> {totalBFare.toFixed(2)} </span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_1" className="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].adult > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].adult} Adult(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {adultTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].child > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].child} Child(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {childTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightAvailibilies && flightAvailibilies.length > 0 && flightAvailibilies[0].infant > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].infant} Infant(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {infantTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_2">
                      <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                        <div className='flex'>
                          <span>Fee & Surcharges</span>
                          <span> <i className='fa fa-inr'></i> {flightAvailibilies &&
                            (
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalServiceTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.baggageCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.mealCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFeeTax || 0),
                                0
                              ) +
                              Number(companyMarkup || 0) +
                              +
                              // Baggage total
                              Object.values(selectedBaggage || {}).reduce(
                                (sum, x) => sum + Number(x?.price || 0),
                                0
                              )
                              +
                              // Meal total
                              Object.values(selectedMeal || {}).reduce(
                                (sum, x) => sum + Number(x?.price || 0),
                                0
                              ) +
                              Object.values(seatSelections || {}).reduce(
                                (segmentSum, segment) =>
                                  segmentSum +
                                  Object.values(segment).reduce(
                                    (paxTypeSum, paxGroup) =>
                                      paxTypeSum +
                                      Object.values(paxGroup).reduce(
                                        (seatSum, seat) => seatSum + Number(seat?.price || 0),
                                        0
                                      ),
                                    0
                                  ),
                                0
                              )
                            ).toFixed(2)}</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_2" className="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">

                        <div className="flex">
                          <span>Seat Charge ({Object.keys(seatSelections || {}).length})</span>
                          <span>
                            <i className="fa fa-inr"></i>{" "}
                            {Object.values(seatSelections)
                              .reduce((segmentSum, segment) => {
                                return (
                                  segmentSum +
                                  Object.values(segment).reduce((paxTypeSum, paxGroup) => {
                                    return (
                                      paxTypeSum +
                                      Object.values(paxGroup).reduce(
                                        (seatSum, seat) => seatSum + Number(seat?.price || 0),
                                        0
                                      )
                                    );
                                  }, 0)
                                );
                              }, 0)
                              .toFixed(2)}
                          </span>
                        </div>
                        <div className="flex">
                          <span>
                            Baggage Charge ({Object.keys(selectedBaggage || {}).length})
                          </span>
                          <span>
                            <i className="fa fa-inr"></i> {baggageTotal.toFixed(2)}
                          </span>
                        </div>

                        <div className="flex">
                          <span>
                            Meal Charge ({Object.keys(selectedMeal || {}).length})
                          </span>
                          <span>
                            <i className="fa fa-inr"></i> {mealTotal.toFixed(2)}
                          </span>
                        </div>

                        <div className='flex'>
                          <span> Fuel Surcharge</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0), 0)
                              .toFixed(2)}</span>
                        </div>

                        {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                          <>
                            <div className='flex'>
                              <span> Tax</span>
                              <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                                (
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                    0
                                  ) -
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.gSTAmount || 0),
                                    0
                                  ) -
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0),
                                    0
                                  )

                                ).toFixed(2)}</span>
                            </div>
                            <div className='flex'>
                              <span>Company Markup</span>
                              <span>
                                <i className='fa fa-inr'></i>{" "}
                                {Number(companyMarkup || 0).toFixed(2)}
                              </span>
                            </div>
                          </>
                        )}
                        {["Corp Travel Manager", "Corporate Traveller"].some(role => roles?.includes(role)) && (
                          <>
                            <div className='flex'>
                              <span> Tax</span>
                              <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                                (
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                    0
                                  ) -
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.gSTAmount || 0),
                                    0
                                  ) -
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0),
                                    0

                                  ) +
                                  flightAvailibilies.reduce(
                                    (sum, x) => sum + parseFloat(x.fareDetails?.companyMarkUp || 0),
                                    0
                                  )

                                ).toFixed(2)}</span>
                            </div>
                          </>

                        )}


                        <div className='flex'>
                          <span> Management Fees</span>
                          <span><i className='fa fa-inr'></i>
                            {flightAvailibilies &&
                              flightAvailibilies
                                .reduce((sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0), 0)
                                .toFixed(2)}
                          </span>
                        </div>
                        <div className='flex'>
                          <span> Management Fees GST</span>
                          <span><i className='fa fa-inr'></i>
                            {flightAvailibilies &&
                              flightAvailibilies
                                .reduce((sum, x) => sum + parseFloat(x.fareDetails?.managementFeeTax || 0), 0)
                                .toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="kt_accordion_1_header_5">
                        <button
                          className="accordion-button fw-semibold collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#kt_accordion_1_body_5"
                        >
                          <div className='flex'>
                            <span>Modify Mark-Up</span>
                          </div>
                        </button>
                      </h2>

                      <div
                        id="kt_accordion_1_body_5"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body">
                          <div className='flex'>
                            <span className="markup">Mark Up</span>
                            <span className="inpt">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter markup"
                                value={companyMarkup}
                                onChange={(e) =>
                                  setCompanyMarkup(Number(e.target.value) || 0)
                                }
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>

                {/* GRAND TOTAL */}
                <div className='d-flexes'>
                  <div className='totals'>GRAND TOTAL</div>
                  <div className="tolt_price">
                    <i className="fa fa-inr"></i>
                    <span>{finalGrandTotal.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section >

      {/* model pop start */}
      < div className="modal fade" id="term-cond" >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Terms And Conditions</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body termsPrivacy">

              <div className='row'>
                <div className='col-md-12 box_shadow'>
                  <p>These Terms of Service (the “User Agreement“) constitute a legally binding agreement made between Berry Journeys Private Limited (“Berry Journeys”), a travel services company incorporated and existing in India in accordance with the Companies Act, 1956 and user, whether personally or on behalf of an entity (“User/User”) and concerning user access to and use of the Berry Journeys.com website as well as mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). </p>
                  <p>Berry Journeys is a travel services website owned and operated by Berry Journeys Private Limited, hereinafter referred to as (“Berry Journeys”/ “we”/ “us” or “our”).
                  </p>
                  <p>User agree that by accessing the site, he has read, understood, and agree to be bound by all of these Terms of Service. If user do not agree with all of these Terms of Service, then the user must discontinue use immediately.</p>
                  <p>Supplemental terms and conditions or documents that may be posted on the site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to this User Agreement at any time and for any reason.
                  </p>
                  <p>We will alert user about any changes by updating the “Last updated” date of these Terms of Use, and user waive any right to receive specific notice of each such change.
                  </p>
                  <p>It is user responsibility to periodically review these Terms of Use to stay informed of updates. User will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by user continued use of the Site after the date such revised Terms of Use are posted.</p>
                  <p>The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country.
                  </p>
                  <p>Accordingly, those persons who choose to access the site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable. </p>

                  <h2>ELIGIBILITY</h2>
                  <p>The site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to register for the site. If user is a minor, User must have user parent or guardian read and agree to these Terms of Use prior to user using the site. </p>



                  <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
                  <p>Unless otherwise indicated, the site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions. </p>
                  <p>The Content and the Marks are provided on the Site “AS IS” for user information and personal use only. Except as expressly provided in these Terms of Use, no part of the site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.
                  </p>
                  <p>Provided that User are eligible to use the Site, User are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which user have properly gained access solely for user personal, non-commercial use. We reserve all rights not expressly granted to user in and to the site, the Content and the Marks.
                  </p>

                  <h2>USER REPRESENTATIONS</h2>
                  <p>By using the site, user represent and warrant that: </p>
                  <ul>
                    <li>All registration information user submit will be true, accurate, current, and complete
                    </li>
                    <li>User will maintain the accuracy of such information and promptly update such registration information as necessary</li>
                    <li>User have the legal capacity and user agree to comply with this User Agreement;</li>
                    <li>User are not under the age of 18;</li>
                    <li>not a minor in the jurisdiction in which user reside, or if a minor, user have received parental permission to use the Site;</li>
                    <li>user will not access the Site through automated or non-human means, whether through a bot, script, or otherwise;</li>
                    <li>User will not use the Site for any illegal or unauthorized purpose;</li>
                    <li>User use of the Site will not violate any applicable law or regulation.</li>
                    <li>If user provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate user account and refuse any and all current or future use of the Site (or any portion thereof).</li>

                  </ul>

                  <h2>USER REGISTRATION</h2>
                  <p>User may be required to register with the Site. User agree to keep user password confidential and will be responsible for all use of user account and password. We reserve the right to remove, reclaim, or change a username user select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable or we have reason to believe that password might have compromised to any external threat.</p>

                  <h2>FRAUDULENT ACTIVITIES, FAKE CALLS & SCAMS</h2>
                  <p>Berry Journey’s representatives will never ask for any personal information like credit/debit card number, CVV, OTP, card expiry date, user IDs, passwords, etc. Also, user will never be asked to install any third-party applications that grant access to user mobile or computer screen.</p>
                  <p>Beware of anyone who is claiming to be associated with Berry Journey’s. Acting on any such requests may make user a victim of fraud, potentially leading to the loss of valuable information or money.</p>
                  <h2>PROHIBITED ACTIVITIES</h2>
                  <p>User may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us. </p>
                  <p>As a User of the Site, user agree not to:
                  </p>
                  <ul>
                    <li>systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                    <li>make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.</li>
                    <li>use a buying agent or purchasing agent to make purchases on the Site.</li>
                    <li>use the Site to advertise or offer to sell goods and services.</li>
                    <li>circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.</li>
                    <li>engage in unauthorized framing of or linking to the Site.</li>
                    <li>trick, defraud, or mislead us and other Users, especially in any attempt to learn sensitive account information such as User passwords;</li>
                    <li>make improper use of our support services or submit false reports of abuse or misconduct.</li>
                    <li>engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
                    <li>interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</li>
                    <li>attempt to impersonate another User or person or use the username of another User.</li>

                  </ul>
                  <h2>sell or otherwise transfer user profile.</h2>
                  <ul>
                    <li>use any information obtained from the Site in order to harass, abuse, or harm another person.</li>
                    <li>use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.</li>
                    <li>decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.</li>
                    <li>attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.</li>
                    <li>harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to user.</li>
                    <li>delete the copyright or other proprietary rights notice from any Content.</li>
                    <li>copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.</li>

                  </ul>
                  <p>upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.</p>
                  <p>upload or transmit (or attempt to upload or transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).</p>
                  <p>except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.</p>
                  <p>disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.</p>
                  <p>use the Site in a manner inconsistent with any applicable laws or regulations.</p>
                  <h1>MOBILE APPLICATION LICENSE</h1>
                  <h2>Use License</h2>
                  <p>If user access the Site via a mobile application, then we grant user a revocable, non-exclusive, non-transferable, limited right to install and use the mobile application on wireless electronic devices owned or controlled by user, and to access and use the mobile application on such devices strictly in accordance with the terms and conditions of this mobile application license contained in these Terms of Use. </p>

                  <h2>User shall not: </h2>
                  <ol>
                    <li> decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt the application; </li>
                    <li>make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application; </li>
                    <li>violate any applicable laws, rules, or regulations in connection with user access or use of the application; </li>
                    <li>remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) posted by us or the licensors of the application; </li>
                    <li>use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended; </li>
                    <li>make the application available over a network or other environment permitting access or use by multiple devices or users at the same time;</li>
                    <li>use the application for creating a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute for the application; </li>
                    <li>use the application to send automated queries to any website or to send any unsolicited commercial e-mail; </li>
                    <li>use any proprietary information or any of our interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of any applications, accessories, or devices for use with the application.</li>
                  </ol>


                  <h2>Apple and Android Devices</h2>
                  <p>The following terms apply when user use a mobile application obtained from either the Apple Store or Google Play Store (each an “App Distributor”) to access the Site:
                  </p>

                  <ol>
                    <li>the license granted to user for our mobile application is limited to a non-transferable license to use the application on a device that utilizes the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the applicable App Distributor’s terms of service; </li>
                    <li> we are responsible for providing any maintenance and support services with respect to the mobile application as specified in the terms and conditions of this mobile application license contained in these Terms of Use or as otherwise required under applicable law, and user acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services with respect to the mobile application; </li>
                    <li>user acknowledge and agree that the App Distributors are third-party beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms and conditions in this mobile application license contained in these Terms of Use against user as a third-party beneficiary thereof.  </li>

                  </ol>
                  <h2>SUBMISSIONS</h2>
                  <p>User acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (“Submissions”) provided by user to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to user. </p>
                  <p>User hereby waive all moral rights to any such Submissions, and user hereby warrant that any such Submissions are original with user or that user have the right to submit such Submissions. User agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in user Submissions. </p>
                  <h2>THIRD-PARTY WEBSITES AND CONTENT</h2>
                  <p>The Site may contain (or user may be sent via the Site) links to other websites (“Third-Party Websites”) as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (“Third-Party Content”). </p>
                  <p>Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. </p>
                  <p>Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If user decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, user do so at user own risk, and user should be aware these Terms of Use no longer govern.
                  </p>
                  <p>User should review the applicable terms and policies, including privacy and data gathering practices, of any website to which user navigate from the Site or relating to any applications user use or install from the Site. Any purchases user make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between user and the applicable third party. </p>
                  <p>User agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and user shall hold us harmless from any harm caused by user purchase of such products or services. Additionally, user shall hold us harmless from any losses sustained by user or harm caused to user relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites. </p>

                  <h2>SITE MANAGEMENT</h2>
                  <p>We reserve the right, but not the obligation, to: </p>
                  <ol>
                    <li>monitor the Site for violations of these Terms of Use;</li>
                    <li>take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such User to law enforcement authorities;
                    </li>
                    <li> in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of user Contributions or any portion thereof; </li>
                    <li> in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; </li>
                    <li>otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.</li>

                  </ol>

                  <h2>PRIVACY POLICY</h2>
                  <p>We care about data privacy and security. Please review our Privacy Policy here to learn more about how we collect and use information about User via our Site. By using the Site, user agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use. </p>
                  <p>We do not knowingly accept, request, or solicit information from children or knowingly market to children. If we receive actual knowledge that anyone under the age of 13 has provided personal information to us without the requisite and verifiable parental consent, we will delete that information from the Site as quickly as is reasonably practical.
                  </p>
                  <h2>INTELLECTUAL PROPERTY RIGHTS INFRINGEMENTS</h2>
                  <p>We respect the intellectual property rights of others. If user believe that any material available on or through the Site infringes upon any Intellectual Property Rights (“IPR”) user own or control, please immediately notify us at hello@BerryJourneys.com. A copy of user notification will be sent to the person who posted or stored the material addressed in the notification.
                  </p>
                  <p>Please be advised that pursuant to applicable law user may be held liable for damages if user make material misrepresentations in user notification. Thus, if user are not sure that material located on or linked to by the Site infringes user IPR, user should consider first contacting an attorney.
                  </p>
                  <h2>FEES AND PAYMENTS</h2>
                  <p>Over and above booking charges for the products/ services offered on the Site, Berry Journeys may charge certain fees in the nature of convenience fees, service fees, finance fee, payment gateway charges (“Additional Fees”) for making services conveniently available to User online. Berry Journeys further reserves the right to alter any and all fees from time to time without prior notice to the User. Any such Additional Fees will be displayed to the User before confirming the booking or collecting the payment to enable user to make an informed choice.</p>
                  <p>The User is responsible for payment of all charges, fees, duties, taxes, and assessments resulting out of the use of the Site, as per the applicable laws. In cases where booking amount, taxes, statutory fee, service fees, convenience fee, payment gateway charges etc. are not properly charged or undercharged (“Balance Amount”), owing to any technical error or other reason, Berry Journeys reserves the right to deduct, charge or claim the Balance Amount from the User and the User shall pay such Balance Amount to Berry Journeys. In cases where such Balance Amount is claimed prior to the utilization of the booking, Berry Journeys will be at liberty to cancel such bookings if the amount is not paid before the utilization date.</p>
                  <p>In the event there is any addition in the prices charged by us as a result of change in applicable law including but not limited to, changes in tax rates or imposition of new taxes, or levies by Government, such increased charge will have to be borne by the User. Berry Journeys may introduce such additional charges without prior notice to the User and could also be retrospective, but will always be as per applicable law.</p>
                  <p>In the rare event of a booking not getting confirmed for any reason whatsoever, Berry Journeys shall not be liable to offer an alternate booking in lieu of or to compensate the unconfirmed booking. Any succeeding booking will be regarded as a new transaction. The pertinent refund will be processed to the User as per the relevant policies of the third party and BERRY JOURNEYS as the case may be.</p>
                  <p>No communication will ever be made by us or any of our employees or authorized representatives enquiring about a User’s credit or debit card number, expiry date, CVV, net banking login, passwords, OTP, request for a fund transfer to a personal or an individual bank account, installation of any third-party applications that enable them to view a User’s mobile or computer screen. Acting on any of these requests may make user a victim of fraud, and may potentially lead to loss of user valuable money or information.</p>
                  <p>Please be advised to not share user personal sensitive information like credit/debit card number, CVV, OTP, card expiry date, user IDs, passwords etc. with any person including the agents, employees or representatives of BERRY JOURNEYS. If any such details are requested by any of our agents, employees or representatives, please inform us at the earliest on the contact details mentioned below. However, BERRY JOURNEYS shall not be liable for any loss that the User incurs for sharing the aforesaid details.</p>
                  <p>All booking(s) made on the Site are subject to the applicable cancellation policy made visible and communicated to the Users on the Site in writing. The applicable refunds on cancelled bookings will be processed to the relevant User account either by way of BERRY JOURNEYS money or reversed to same banking instrument (credit card, debit card, Bank account, wallet etc.) from which initial payment was made.</p>

                  <h2>TERM AND TERMINATION</h2>
                  <p>This User Agreement shall remain in full force and effect while user use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THIS USER AGREEMENT, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THIS USER AGREEMENT OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE USER USE OR PARTICIPATION IN THE SITE OR DELETE USER ACCOUNT AND ANY CONTENT OR INFORMATION THAT USER POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION. </p>
                  <p>If we terminate or suspend user account for any reason, user are prohibited from registering and creating a new account under user name, a fake or borrowed name, or the name of any third party, even if user may be acting on behalf of the third party. </p>
                  <p>In addition to terminating or suspending user account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.</p>
                  <h2>MODIFICATIONS AND INTERRUPTIONS </h2>
                  <p>We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. </p>
                  <p>We will not be liable to user or any third party for any modification, price change, suspension, or discontinuance of the Site. </p>
                  <p>We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. </p>
                  <p>We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice. User agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by user inability to access or use the Site during any downtime or discontinuance of the Site. </p>
                  <p>Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.</p>

                  <h2>GOVERNING LAW </h2>
                  <p>This User Agreement and user use of the Site are governed by and construed in accordance with the laws of India and the Parties shall refer any unresolved disputes to the exclusive jurisdiction of courts in Delhi.  </p>

                  <h2>CORRECTIONS</h2>
                  <p>There may be information on the Site that contains typographical errors, inaccuracies, or omissions that may relate to the Site, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.</p>

                  <h2>DISCLAIMER</h2>
                  <p>THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. USER AGREE THAT USER USE OF THE SITE AND OUR SERVICES WILL BE AT USER SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND USER USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM USER ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN USER AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. </p>
                  <p>AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, USER SHOULD USE USER BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.</p>

                  <h2>LIMITATIONS OF LIABILITY</h2>
                  <p>IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO USER OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, </p>
                  <p>INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM USER USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. </p>
                  <p>NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO USER FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE TOTAL AMOUNT OF TRANSACTION IN QUESTION.
                  </p>
                  <h2>INDEMNIFICATION</h2>
                  <p>User agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorney’s fees and expenses, made by any third party due to or arising out of:</p>
                  <ol>
                    <li> user Contributions</li>
                    <li>use of the Site</li>
                    <li>breach of these Terms of Use; </li>
                    <li>any breach of user representations and warranties set forth in these Terms of Use;</li>
                    <li>user violation of the rights of a third party, including but not limited to intellectual property rights;</li>
                    <li>any overt harmful act toward any other user of the Site with whom user connected via the Site. </li>
                  </ol>
                  <p>Notwithstanding the foregoing, we reserve the right, at user expense, to assume the exclusive defense and control of any matter for which user are required to indemnify us, and user agree to cooperate, at user expense, with our defense of such claims. We will use reasonable efforts to notify user of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it. </p>
                  <h2>USER DATA</h2>
                  <p>We will maintain certain data that user transmit to the Site for the purpose of managing the Site, as well as data relating to user use of the Site. Although we perform regular routine backups of data, user are solely responsible for all data that user transmit or that relates to any activity user have undertaken using the Site. </p>
                  <p>User agree that we shall have no liability to user for any loss or corruption of any such data, and user hereby waive any right of action against us arising from any such loss or corruption of such data.</p>
                  <h2>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND BERRYS</h2>
                  <p>Visiting the Site, sending us emails, and completing online forms constitute electronic communications. User consent to receive electronic communications, and user agree that all agreements, notices, disclosures, and other communications we provide to user electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. </p>
                  <p>USER HEREBY AGREE TO THE USE OF ELECTRONIC BERRYS, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. </p>
                  <p>User hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original Berry or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means. </p>
                  <p>For ease of Users, we also send booking confirmations, itinerary information, cancellations, payment confirmation/status, refund status, booking failure information or any such other information relevant to the transaction or booking made by the User, via SMS, internet-based messaging applications like WhatsApp, voice call, e-mail or any other alternate communication information furnished by the User at the time of booking.</p>
                  <p>User hereby consent that any such communication through SMS, WhatsApp, voice call, email or any other mode by us are:</p>
                  <ul>
                    <li>as per user request and authorization;</li>
                    <li>‘transactional’ and not an ‘unsolicited commercial communication’ as per the guidelines of Telecom Regulation Authority of India (TRAI), and</li>
                    <li>in compliance with appropriate guidelines of TRAI or other relevant authority in India and abroad as applicable.</li>
                  </ul>
                  <p>User hereby agree to indemnify us against any losses and damages incurred by us due to any action taken by TRAI or any other authority due to any erroneous complaint filed by the User on us on account of communications sent to User as above or failed communication due to a wrong number or email ID shared by the User for any reason whatsoever.</p>
                  <h2>MISCELLANEOUS</h2>
                  <p>This User Agreement and any policies or operating rules posted by us on the Site constitute the entire agreement and understanding between User and Berry Journeys. Our failure to exercise or enforce any right or provision of this User Agreement shall not operate as a waiver of such right or provision. </p>
                  <p>This User Agreement operates to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.</p>
                  <p>If any provision or part of a provision of this User Agreement is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from this User Agreement and does not affect the validity and enforceability of any remaining provisions. </p>
                  <p>There is no joint venture, partnership, employment or agency relationship created between user and us as a result of this User Agreement or use of the Site. User agree that this User Agreement will not be construed against us by virtue of having drafted them. </p>
                  <p>User hereby waive any and all defenses user may have based on the electronic form of this User Agreement.</p>

                  <h2>CONTACT US </h2>
                  <p>In order to resolve a complaint regarding the Site or to receive further information regarding the use of the Site, please contact us at: </p>
                  <h6>Berry Journeys Private Limited<br />
                    2nd Floor, Plot no 3, IFFCO Tower,<br />
                    Sector 29, Gurugram Haryana India – 122001<br />
                    Email Address: hello@Berry Journeys.com
                  </h6>
                  <h1>TERMS OF SERVICE</h1>
                  <p>All Services offered on Site shall be governed by the following Terms of Service:</p>

                  <h1>Flights</h1>
                  <p>BERRY JOURNEYS as a booking platform
                  </p>
                  <p> BERRY JOURNEYS provides a facilitator platform to enable the user to book a flight ticket. The flight tickets shown to User on the Site for booking are subject to the terms and conditions of the concerned airline, including but not limited to delay, change, cancellation and refund.</p>
                  <p>Each respective airline retains the right to reschedule the timings of the flights, routes, cancellation or change in itineraries without prior intimation to us. As a facilitator, BERRY JOURNEYS has no control or authority over the logistics of the airlines and therefore is not liable for any loss, direct or incidental, that a User may suffer due to change in details or cancellation of a booked flight. Any grievances, if any, will be handled and decided directly by the concerned airline.</p>
                  <p>the User shall ensure to carry and have sole responsibility of carrying valid travel documents at the time of the journey including but not limited to identity proof, passport, visa (including transit visa if applicable) to prove the identity, nationality and age of passengers (adult or infant) travelling on a ticket. BERRY JOURNEYS shall have no liability for damages arising out of User inability to carry valid or appropriate documents at the time of travel.</p>
                  <p> In the event that a User does not board the onward flight on the day of travel, the entire PNR generated for that booking shall stand cancelled. BERRY JOURNEYS under no circumstances will be liable to compensate the User for missing the flight. In such an event, the airline cancellation policy will be applicable.</p>
                  <p> Check-in timings may vary from airline to airline. Users are hereby advised to check with the airline prior for the check-in timings. Usually, check-in commences two (02) hours before departure for domestic flights, and 3 hours before departure for international flights. Pricing: Airfares shown on our platform are inclusive of various airline charges, including but not limited to Base Fare, Fuel Surcharge, User Development Fees, Passenger Service Fees, Terminal Equipment Fee, Airport Development fee, etc. as the case may be and Government Taxes. Additionally, we charge convenience/service fee (collectively referred to as “Fee”) for providing the online booking facility varying parameters selected by the User at the time of booking. The User hereby agrees to pay the entire amount including all statutory taxes, surcharges and fees, as applicable at the time of booking the ticket.</p>
                  <p> Different tickets on the same airline may carry different limitations or include different services and price, as the case may be. The baggage allowance on a given flight is shown as per the terms of the airline, and is not controlled by us. There may be instances where airline imposes “hand baggage fares” wherein User will be required to pay separately for check-in baggage. The prices for adding check-in baggage to a booking may vary from airline to airline. The User is advised to get in touch with the airlines for detailed costs/charges. Infant Fares: Infant Fares will be applicable subject to the following conditions:</p>
                  <ul>
                    <li>The infant must be accompanied by an adult as per the terms of the airline.</li>
                    <li> The infant must be under 24 months of age throughout the journey i.e. both onward as well as return journey.</li>
                    <li> If the infant turns 24 months or above at the time of return journey, User will be required to make a separate booking as per applicable child fare. Changes to existing booking: The User shall be liable to pay applicable charges (charged by the respective airline and BERRY JOURNEYS) for any alteration or modification to an existing booking. However, depending on the concerned airline’s policy and fare class, amount of charge may vary.
                    </li>

                  </ul>
                  <p>Cancellations and Refunds: All refunds are subject to airline fare rules and cancellation policy, and shall be made by BERRY JOURNEYS only on the receipt of such refund from the airline. Users are hereby advised to check with the airline in advance and read about their cancellation policy.
                    THE USER AGREES THAT ANY FEE CHARGED BY BERRY JOURNEYS INCLUDING BERRY JOURNEYS SERVICE FEE AND CONVENIENCE FEE PAID BY THE USER AT THE TIME OF BOOKING IS A NON-REFUNDABLE FEE. ANY REFUND TO THE USER SHALL BE PROCESSED AFTER DEDUCTING EQUIVALENT AMOUNT TOWARDS THE FEE.    </p>
                  <p>Please intimate us at the earliest where any cancellations are made directly with the airline in order to initiate the process of refund to the User. The processing time for refunds may differ depending on the mode of payment, bank etc. In instances where tickets were only partially utilized, refund shall be made after deducting any discount and/or promo code discount availed at the time of booking.
                    The refund will be credited to the User bank account/ credit card/debit card/wallet etc. from which the payment was originally made by the User unless the User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS charges. For instance, if the User used a credit card, the refund will be made to the corresponding credit card. Similarly, if the User had used a debit card for the payment, refund will be made to the same debit card.</p>
                  <p> BERRY JOURNEYS Fare Recommendations help the Users to identify the best time to book their flights. BERRY JOURNEYS recommendations are based on our proprietary data model which is derived from analysis of historical prices. However, we do not guarantee the final outcome
                  </p>
                  <h1>HOTELS</h1>
                  <p>Role of BERRY JOURNEYS as a Booking Platform
                  </p>
                  <p>For ease of Users to book Hotels online, BERRY JOURNEYS has partnered with various hotel aggregators (“Hotel Aggregators”) by providing a technology platform for booking Hotels and collecting payments directly on BERRY JOURNEYS platform. Our Site allow Users to search across multiple Hotel accommodation providers in a selected area including BERRY JOURNEYS as a booking platform wherever applicable. Based
                  </p>
                  <p>Under this arrangement, BERRY JOURNEYS provides a technology platform, facilitating transactions between Hotels and Users by providing them with a choice of Hotel types, check-in and check-out time etc.</p>
                  <p>However, we do not own or operate any Hotel services of our own. The selection of any specific Hotel is entirely on the choice of User. BERRY JOURNEYS shall not be responsible for the operations of the Hotel and any service related disputes shall be raised directly with the Hotel.
                  </p>
                  <p>BERRY JOURNEYS acts as an online facilitator platform for the User to select and book a particular Hotel by collating data relating to Hotel availability from various Booking Partners websites based on User search criteria.</p>
                  <p> ‘Hotel’ shall mean all categories of accommodations like hotels, home-stays, bed and breakfast stay, etc.</p>
                  <p><strong>Eligibility</strong> : The primary guest must be at least 18 years of age to be able to book and check-in to the hotel.</p>
                  <h2></h2>
                  <h2>Role and Responsibility of the Booking Partners:</h2>
                  <p>addressing any User complaint or dispute relating to the category of the hotel and/or sufficiency of services, room type selected, amenities and facilities offered at the Hotel. All information displayed on the Site only for reference purposes. BERRY JOURNEYS shall not be liable for any dispute arising from wrong information conveyed.</p>
                  <h2>Role and Responsibility of the Booking Partners:</h2>
                  <p>any service-related issues at the Hotel such as change in check-in/ check-out timings, extra bedding, delay in check in due to over-booking, system or technical errors, non-availability of rooms etc.
                  </p>
                  <p>All issues relating to payment options i.e. prepaid/postpaid etc will be governed by respective Booking Partner’s and/or Hotel policies.</p>
                  <h1>BUSES</h1>
                  <p> For ease of booking online bus tickets, BERRY JOURNEYS has partnered with various bus aggregators (“Aggregators”) to provide a technology platform for purchase of bus tickets through their channel of bus operators.</p>
                  <p> Aggregators enable travelers to book bus tickets online by providing them with a choice of bus operators, departure time and prices. However, Aggregators do not own or operate any bus services of their own. The selection of any specific bus operator is entirely on the choice of User. Under this arrangement, BERRY JOURNEYS merely provides a technology platform, facilitating transactions between the bus operators and Users. BERRY JOURNEYS shall not be responsible for the operations of the bus operator including, but not limited to the following:
                  </p>
                  <h2>Departure or arrival of the buses on time;</h2>
                  <p>The conduct/behaviour of bus driver or bus operator’s employees, representatives or agents;</p>
                  <ul>
                    <li>The physical condition of the bus, seats etc. not being up to the User’s expectation or as per the description furnished by the bus operator on the Platform;</li>
                    <li>Cancellation of the scheduled trip due to any reasons;</li>
                    <li>Loss or damage to the User’s luggage;</li>
                    <li>Change in allocated seat to the User by the bus operator for any reason whatsoever;</li>
                  </ul>
                  <p>Bus operator notifying an incorrect boarding point on the booking confirmation voucher, or altering such boarding point later with or without any notification to BERRY JOURNEYS or the User;</p>
                  <p>Bus operator using a different pick-up vehicle for transportation of the customers from the designated boarding point to the actual place of departure of the bus.</p>
                  <p>Users are hereby recommended to get in touch with the bus operators in advance for details relating to exact boarding point, charges for additional baggage (if any) or any other information needed for boarding or travel for the scheduled journey.</p>
                  <ul>
                    <li> Users are required to carry following documents at the time of boarding the bus:</li>
                    <li>a print out of the ticket, and</li>
                    <li>any valid ID like Aadhar card, passport, PAN card or voter ID or any other valid identity proof issued by a government authority.</li>
                    <li>Users are advised to reach the boarding place no later than thirty (30) minutes before the scheduled departure time. All tickets issued shall be non-transferable.</li>
                  </ul>
                  <p>In the event of cancellation of bus ticket on the Site, refund will be made after deduction of applicable Aggregator and BERRY JOURNEYS cancellation charges. Users are advised to read through cancellation terms mentioned on the ticket/Site carefully.
                    Convenience/Service fee charged by BERRY JOURNEYS at the time of booking the tickets are non-refundable. The refund in such circumstances gets credited to BERRY JOURNEYS money and/or same User bank account/Credit card/Debit card/Wallet etc used for booking tickets unless User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS charges.</p>

                  <h1>TRAINS</h1>
                  <p>BERRY JOURNEYS acts as a facilitator for Users to book and search for desired train tickets on IRCTC platform. All train bookings or reservations made on the Site are subject to the applicable terms and conditions as set out by IRCTC Booking Process</p>
                  <p>To book train tickets, User will be redirected to IRCTC website/application. Users will need their IRCTC username and password in order to book their tickets on BERRY JOURNEYS website/application.E-tickets are booked and issued through Indian Railways only and are subject to the rules and policies of Indian Railways. Users can book a maximum of 6 seats/ berths in a booking. Seat/ berth allotment is done by Indian Railways based on their allocation logic. BERRY JOURNEYS does not guarantee allotment of preferred seat/ berth. Users with a confirmed e-ticket are permitted to board the train. Their names will appear on the chart. Fully waitlisted e-tickets are automatically cancelled by IRCTC after chart preparation. If fully waitlisted passengers are found travelling, they will be treated as without-ticket and charged as per Railway rules.Booked tickets are non-transferrable and are subject to identification. Users must carry valid ID proofs such as PAN card/ Aadhar Card/ Voter ID etc. at the time of travel or boarding the train for validation.</p>
                  <p>BERRY JOURNEYS will not be responsible for any schedule change by the Railways. Users are advised to confirm their train timings 24 hours prior to the train departure.</p>
                  <p> The Railways rules and regulations may change from time to time. Please refer to</p>
                  <p>http://www.indianrail.gov.in/enquiry/StaticPages/StaticEnquiry.jsp?StaticPage=index.html for the latest rules and regulations. While we endeavor to keep the rules and regulations updated at all times but should not be held responsible for the same.</p>
                  <p> Please reach out to IRCTC directly for all relevant information/ queries relating to user bookings.</p>

                  <h2>Modifications</h2>
                  <p>BERRY JOURNEYS cannot make any modifications to the booked tickets, including but not limited to change in passenger names, change in route, boarding point etc. Any modifications to booked tickets can be made only by IRCTC. We suggest Users to read IRCTC amendment policy here https://www.services.irctc.co.in/beta_htmls/Eticket_new_cancel.html to know more details.
                  </p>
                  <p>Payments, Cancellations and RefundsCancellation of booked tickets are subject to IRCTC cancellation policy and charges as per time of cancellation and booking quota (tatkal/ general/ ladies/ premium, etc.) Customers are advised to go through IRCTC cancellation policy prior to cancellation to know about the relevant cancellation charges. User can cancel a train ticket booked via BERRY JOURNEYS, only before chart preparation.</p>
                  <p> Cancellation charges may vary depending on ticket type and time of ticket cancellation. Cancellations and refunds will be based on Indian Railways refund and TDR filing rules. These rules are subject to change by Indian Railways.</p>
                  <p> User can find complete details of the Railway cancellation policy and rules here: http://www.indianrail.gov.in/enquiry/StaticPages/StaticEnquiry.jsp?StaticPage=refund_Rules.html&locale=en or http://contents.irctc.co.in/en/eticketCancel.html</p>
                  <p>Payment Gateway charges/service fee charged by BERRY JOURNEYS at the time of booking the tickets are non-refundable. The refund gets credited to same User bank account/credit card/debit card/wallet, etc. used for booking tickets unless User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS’s charges.</p>
                  <h2>USER GENERATED CONTRIBUTIONS</h2>
                  <p>The Site may invite user to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide user with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, “Contributions”). </p>
                  <p>Contributions may be viewable by other Users of the Site and through third-party websites. As such, any Contributions user transmit may be treated as non-confidential and non-proprietary. When user create or make available any Contributions, user thereby represent and warrant that:</p>
                  <p>the creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of user contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.</p>
                  <p>user are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the site, and other users of the Site to use user Contributions in any manner contemplated by the Site and these Terms of Use.</p>
                  <p>user have the written consent, release, and/or permission of each and every identifiable individual person in user Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of user Contributions in any manner contemplated by the Site and these Terms of Use.
                  </p>
                  <p>user Contributions are not false, inaccurate, or misleading.</p>
                  <ul>
                    <li>user Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.
                    </li>
                    <li>user Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).</li>
                    <li>user Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.
                    </li>
                    <li>user Contributions do not violate any applicable law, regulation, or rule.</li>
                    <li>user Contributions do not violate the privacy or publicity rights of any third party.</li>
                    <li>user Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.</li>
                    <li>user Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.</li>
                    <li>Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of user rights to use the Site. </li>
                  </ul>
                  <h2>CONTRIBUTION LICENSE</h2>
                  <p>By posting user Contributions to any part of the Site or making Contributions accessible to the Site by linking user account from the Site to any of user social networking accounts, user automatically grant, and user represent and warrant that user have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, user image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels. </p>
                  <p>This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of user name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images user provide. User waive all moral rights in user Contributions, and user warrant that moral rights have not otherwise been asserted in user Contributions. </p>
                  <p>We do not assert any ownership over user Contributions. User retain full ownership of all of user Contributions and any intellectual property rights or other proprietary rights associated with user Contributions. We are not liable for any statements or representations in user Contributions provided by user in any area on the Site.
                  </p>
                  <p>User are solely responsible for user Contributions to the Site and user expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding user Contributions.</p>
                  <p>We have the right, in our sole and absolute discretion,</p>
                  <ol>
                    <li>to edit, redact, or otherwise change any Contributions;</li>
                    <li> to re-categorize any Contributions to place them in more appropriate locations on the Site; and </li>
                    <li>to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor user Contributions. </li>

                  </ol>

                  <h2>GUIDELINES FOR REVIEWS</h2>
                  <p>We may provide user areas on the Site to leave reviews or ratings. When posting a review, user must comply with the following criteria:</p>
                  <ul>
                    <li>user should have firsthand experience with the person/entity being reviewed</li>
                    <li>user reviews should not contain offensive profanity, or abusive, racist, offensive, or hate language</li>
                    <li>user reviews should not contain discriminatory references based on religion, race, gender, national origin, age, marital status, sexual orientation, or disability;
                    </li>
                    <li>user reviews should not contain references to illegal activity;
                    </li>
                    <li>user should not be affiliated with competitors if posting negative reviews;</li>
                    <li>user should not make any conclusions as to the legality of conduct;</li>
                    <li>user may not post any false or misleading statements;</li>
                    <li>user may not organize a campaign encouraging others to post reviews, whether positive or negative.</li>


                  </ul>

                  <p>We may accept, reject, or remove reviews in our sole discretion. We have absolutely no obligation to screen reviews or to delete reviews, even if anyone considers reviews objectionable or inaccurate. Reviews are not endorsed by us, and do not necessarily represent our opinions or the views of any of our affiliates or partners. </p>
                  <p>We do not assume liability for any review or for any claims, liabilities, or losses resulting from any review. By posting a review, user hereby grant to us a perpetual, non-exclusive, worldwide, royalty-free, fully-paid, assignable, and sublicensable right and license to reproduce, modify, translate, transmit by any means, display, perform, and/or distribute all content relating to reviews.</p>

                  <h1>SOCIAL MEDIA</h1>
                  <p>As part of the functionality of the Site, user may link user account with online
                    accounts user have with third-party service providers (each such account, a “Third-Party
                    Account”) by either:
                  </p>
                  <ol>
                    <li>providing user Third-Party Account login information through the Site; or</li>
                    <li>allowing us to access user Third-Party Account, as is permitted under the applicable
                      terms and conditions that govern user use of each Third-Party Account. </li>

                  </ol>
                  <p>User represent and warrant that user are entitled to disclose user Third-Party Account login information to us and/or grant us access to user Third-Party Account, without breach by user of any of the terms and conditions that govern user use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account. </p>
                  <p>By granting us access to any Third-Party Accounts, user understand that </p>
                  <ol>
                    <li>we may access, make available, and store (if applicable) any content that user have provided to and stored in user Third-Party Account (the “Social Network Content”) so that it is available on and through the Site via user account, including without limitation any friend lists and </li>
                    <li> we may submit to and receive from user Third-Party Account additional information to the extent user are notified when user link user account with the Third-Party Account. </li>
                  </ol>
                  <p>Depending on the Third-Party Accounts user choose and subject to the privacy settings that user have set in such Third-Party Accounts, personally identifiable information that user post to user Third-Party Accounts may be available on and through user account on the Site. </p>
                  <p>Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Site. User will have the ability to disable the connection between user account on the Site and user Third-Party Accounts at any time.</p>
                  <p>PLEASE NOTE THAT USER RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH USER THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY USER AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS.</p>
                  <p>We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. </p>
                  <p>User acknowledge and agree that we may access user email address book associated with a Third-Party Account and user contacts list stored on user mobile device or tablet computer solely for purposes of identifying and informing user of those contacts who have also registered to use the Site</p>
                  <p>User can deactivate the connection between the Site and user Third-Party Account by contacting us using the contact information below or through user account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Accounts, except the username and profile picture that become associated with user account.</p>



                </div>


              </div>

            </div>
          </div>
        </div>
      </div >


      <div
        className="modal fade"
        id="duplicateBookingModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Duplicate Booking
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body p-4">

              <div className="text-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center mx-auto mb-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "#fff3cd",
                    fontSize: "24px"
                  }}
                >
                  ⚠️
                </div>

                <p className="mb-2 fw-semibold">
                  {duplicateMessage}
                </p>

                <p className="text-muted mb-0">
                  This booking appears to be a duplicate of an existing booking.
                </p>
              </div>

              <div
                className="border rounded p-3"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <div className="row align-items-center">
                  <div className="col-5 text-muted">
                    Reference No.
                  </div>

                  <div className="col-7 text-end">
                    {/* <span className="fw-bold">
                      {duplicateReferenceNo}
                    </span> */}
                    <a
                      href={`/reservations/flight/TransactionDetails?referenceNo=${duplicateReferenceNo ?? ""}&trackID=${duplicateTrackId ?? ""}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fw-bold text-primary text-decoration-none"
                    >
                      {duplicateReferenceNo}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              {/* <button
                type="button" className="btn btn-primary px-4"
                onClick={() => {
                  window.open(
                    `/reservations/flight/TransactionDetails?referenceNo=${duplicateReferenceNo ?? ""}&trackID=${duplicateTrackId ?? ""}`,
                    "_blank"
                  );
                }}
                title="Details"
              >
                View Details
              </button> */}
              <button
                type="button"
                className="btn btn-primary px-4"
                data-bs-dismiss="modal"
                onClick={() => {
                  ContinueBooking();
                }}
              >
                Continue
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  )
};

export default Booking;
